// 2024-10-07T09:50:14.113Z  (1728294614113)
export const locale = {
	lang: 'da',
	data: {
		'ACCOUNTING_VALUE': 'Afregningsenhed',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Beregning kun i udvalgte arbejdsstater',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Værdiaggregering',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Beregning af værdi',
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Værdiopregning',
		'ACCOUNT_ACTIVATION': 'Aktivering af konto',
		'ACCOUNT_ACTIVATION.CODE': 'Aktiveringskode',
		'ACCOUNT_ACTIVATION.CODE.RESEND': 'Send aktiveringskoden igen',
		'ACCOUNT_ACTIVATION.INTRO': 'Indtast den aktiveringskode, du har modtaget via e-mail.',
		'ACID': 'Syre',
		'ACTIVATE': 'Aktiver',
		'ACTIVATE.SELECTED': 'Aktiver den valgte',
		'ACTIVE': 'Aktiv',
		'ACTIVITIES.DAILY': 'Daglige aktiviteter',
		'ACTIVITIES.EXPORT': 'Eksportaktiviteter',
		'ACTIVITIES.NO': 'Ingen aktiviteter',
		'ACTIVITIES.WEEKLY': 'Ugentlige aktiviteter',
		'ACTIVITY': 'Aktivitet',
		'ACTIVITY.EXPORT_DETAILS': 'Eksport af den valgte aktivitet',
		'ACTIVITY.NO_FIELDS_WORKED': 'Der blev ikke arbejdet på registrerede marker.',
		'ADAPTER': 'Adapter',
		'ADAPTER.ASSIGN': 'Tildele adapter',
		'ADAPTER.ASSIGN.FAILURE': 'Der opstod en fejl ved forbindelse af adapteren.',
		'ADAPTER.ASSIGN.SUCCESS': 'Adapter tildelt med succes',
		'ADAPTER.ASSIGNED_MACHINE': 'Tildelt maskine',
		'ADAPTER.ASSIGNMENT': 'Tildeling af adapter til maskine',
		'ADAPTER.CHOSEN': 'Valgt adapter',
		'ADAPTER.LOAD.FAILURE': 'Der opstod en fejl ved indlæsning af adapteren.',
		'ADAPTER.NO': 'Ingen adapter',
		'ADAPTER.NONE_AVAILABLE': 'Ingen adapter tilgængelig',
		'ADAPTER.PAIR_INFO': 'Vælg den tilsvarende adapter. Allerede tildelte adaptere overskrives med den nye maskine. Den nye adapterkonfiguration indlæses automatisk ved næste genstart af adapteren.',
		'ADAPTER.PREVIOUS': 'Forrige adapter',
		'ADAPTERS.NO': 'Ingen adaptere',
		'ADBLUE.LEVEL': 'AdBlue-fyldningsniveau',
		'ADD': 'Tilføj',
		'ADDITIONAL_VALUE': 'Ekstra værdi',
		'ADDITIVE': 'Tilsætningsstof',
		'ADDRESS': 'Adresse',
		'ALL': 'Alle',
		'ALL_DEVICES': 'Samlet adapter',
		'AMOUNT': 'Mængde',
		'AMOUNT.INVALID': 'Mængde ugyldig.',
		'AMOUNTS': 'Beløb',
		'APPLY': 'Anvend',
		'ARCHIVE': 'Arkiv',
		'ARCHIVE.SELECTED': 'Arkiv valgt',
		'AREA': 'Område',
		'AREA.FIELD': 'Areal',
		'AREA.LOCATION': 'Områdets placering',
		'AREA.PERFORMANCE': 'Arealydelse',
		'AREA.PROCESSED': 'Bearbejdet areal',
		'AREA.TOTAL': 'Samlet areal',
		'AREA.WORKED': 'Bearbejdet område',
		'ASSIGN': 'Tildel',
		'AUTH.REMEMBER_ME': 'Husk mig',
		'BACK': 'Tilbage',
		'BALES': 'Bales',
		'BASIC_DATA': 'Grundlæggende data',
		'BEACON': 'Beacon',
		'BEACON.ASSIGN': 'Tildele beacon',
		'BEACON.ASSIGN.SUCCESS': 'Beacon blev tildelt',
		'BEACON.ASSIGNED_EMPLOYEE': 'Tildelt medarbejder',
		'BEACON.ASSIGNED_IMPLEMENT': 'Tildelt påhængsredskab',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Tildeling af beacon til medarbejder',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Tildeling af beacon til gennemførelse',
		'BEACON.CHOSEN': 'Valgt Beacon',
		'BEACON.ERROR': 'Der opstod en fejl under forbindelsen af Beacon.',
		'BEACON.LOAD_ERROR': 'Der opstod en fejl ved indlæsning af Beacon',
		'BEACON.NONE_AVAILABLE': 'Ingen Beacon tilgængelig',
		'BEACON.NO_BEACON': 'Ingen Beacon',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Vælg det tilsvarende signal. Allerede tildelte beacons vil blive overskrevet med den nye medarbejder.',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Vælg den pågældende Beacon. Allerede tildelte beacons overskrives med det nye påhængsredskab.',
		'BEACON.PREVIOUS': 'Forrige beacon',
		'BEACONS': 'Beacons',
		'BUILD_YEAR': 'Byggeår',
		'BUILD_YEAR.INVALID': 'Byggeår ugyldigt',
		'CAN.STATUS': 'CAN-status',
		'CANCEL': 'Afbryd',
		'CHANGE': 'Ændre',
		'CHANGE.NO': 'Ingen ændring',
		'CHOOSE_ALL': 'Vælg alle',
		'CHOOSE_ROLE': 'Vælg en rolle',
		'CHRONOLOGICAL': 'Kronologisk forløb',
		'CLICK_PROCESS': 'Vælg en proces for at få yderligere detaljer.',
		'CLOSE': 'Luk',
		'CO2.EMISSION': 'CO2 emission',
		'CO2.PER': 'Mængde af CO2 pr. ha',
		'CO2.TOTAL': 'Samlet mængde CO2',
		'COLOR': 'Farve',
		'COMMENT': 'Kommentar',
		'CONDITION': 'Betingelse',
		'CONFIRM': 'Bekræft',
		'CONFIRM_PASSWORD': 'Bekræft adgangskode',
		'CONNECT': 'Forbind',
		'CONTACT_PERSON': 'Kontaktperson',
		'CONTINUE': 'Næste',
		'COST': 'Omkostninger',
		'COST.INVALID': 'Omkostninger ugyldige',
		'COST.OVERALL': 'Samlet pris',
		'COST.OVERALL.ARRIVAL': 'Samlet omkostning ved ankomst',
		'COST.OVERALL.DRIVER': 'Overordnet omkostningsdriver',
		'COST.OVERALL.FIELD_TIME': 'Samlede omkostninger på marken',
		'COST.OVERALL.IMPLEMENTS': 'Samlede omkostninger implementerer',
		'COST.OVERALL.MACHINES': 'Samlet pris for maskiner',
		'COST.OVERALL.PREPARATION': 'Forberedelse af samlede omkostninger',
		'COST.TOTAL': 'Samlede omkostninger',
		'COSTS': 'Omkostninger',
		'COST_RATE': 'Omkosningsrate',
		'COUNTRY': 'Land',
		'COVERAGE': 'Coverage',
		'COVERAGE.MAP': 'Kort over dækning',
		'COVERAGE.MAP.SETTINGS': 'Indstillinger for dækningskort',
		'COVERAGE.MAP.ZONES': 'Zoner',
		'CREATED': 'Oprettet',
		'CREATE_USER': 'Opret bruger',
		'CROP.TYPE': 'Afgrødetype',
		'CROP.NO_CROP': 'Ingen afgrøde',
		'CURRENCY': 'Valuta',
		'CUSTOMER': 'Kunde',
		'CUSTOMER.ADD': 'Tilføj kunde',
		'CUSTOMER.ADD.SUCCESS': 'Kunde succesfuldt tilføjet',
		'CUSTOMER.ASSIGN': 'Tildele kunde',
		'CUSTOMER.DELETE.QUESTION': 'Er du sikker på, at kunden skal fjernes?',
		'CUSTOMER.DELETE.SUCCESS': 'Kunde fjernet',
		'CUSTOMER.DETAILS': 'Oplysninger om kunden',
		'CUSTOMER.EDIT': 'Rediger kunde',
		'CUSTOMER.EDIT.SUCCESS': 'Kunde succesfuldt redigeret',
		'CUSTOMER.NAME': 'Kundenavn',
		'CUSTOMER.NO': 'Vælg først en kunde!',
		'CUSTOMER.NOT_SELECTED': 'Ingen kunde valgt',
    'CUSTOMER.NO.ASSIGNEE': 'Ingen kunde tildelet',
		'CUSTOMER.SELECT': 'Vælg kunde',
		'CUSTOMERS': 'Kunder',
		'CUSTOMERS.ALL': 'Alle kunder',
		'CUSTOMERS.DELETE.FAILURE': 'Nogle af kunderne kunne ikke slettes.',
		'CUSTOMERS.DELETE.QUESTION': 'Ønsker du at slette de valgte kunder?',
		'CUSTOMERS.DELETE.SUCCESS': 'Kunder slettet med succes',
		'CUSTOMERS.MANAGEMENT': 'Kundeadministration',
		'CUSTOMERS.NO': 'Ingen kunder',
		'CUSTOMERS.SELECTED': 'Udvalgte kunder',
		'CUSTOM_LABELING': 'Brugerdefineret mærkning',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Tilføj ny arbejdsstatus',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Definer en brugerdefineret mærkning for det valgte værktøj.',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Definer individuelle betingelser for etiketten.',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Redigering af brugerdefineret mærkning lykkedes',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Individuel tilstand',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Tillad overstyring med ISOBUS-betingelser',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'Ingen label tilgængelig',
		'DASHBOARD.GPS_DATA.NO': 'Ingen GPS-data',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'Der var en fejl ved indlæsning af maskinens positioner',
		'DATA': 'Data',
		'DATA.ARCHIVED.WARNING': 'Underliggende data er helt eller delvist arkiveret',
		'DATA.EXPORT': 'Eksport af data',
		'DATA.INPUT': 'Data input',
		'DATA.UPDATING.WARNING': 'Underliggende data er ved at blive opdateret',
		'DATA_PREPARATION': 'Databehandling',
		'DATE': 'Dato',
		'DATE.APRIL': 'April',
		'DATE.AUGUST': 'August',
		'DATE.DECEMBER': 'December',
		'DATE.FEBRUARY': 'Februar',
		'DATE.FRIDAY': 'Fredag',
		'DATE.FROM': 'Fra (Dato)',
		'DATE.JANUARY': 'Januar',
		'DATE.JULY': 'Juli',
		'DATE.JUNE': 'Juni',
		'DATE.MARCH': 'Marts',
		'DATE.MAY': 'Maj',
		'DATE.MONDAY': 'Mandag',
		'DATE.NOVEMBER': 'November',
		'DATE.OCTOBER': 'Oktober',
		'DATE.PERIOD': 'Interval',
		'DATE.RANGE': 'Datointerval',
		'DATE.SATURDAY': 'Lørdag',
		'DATE.SEPTEMBER': 'September',
		'DATE.SUNDAY': 'Søndag',
		'DATE.THURSDAY': 'Torsdag',
		'DATE.TUESDAY': 'Tirsdag',
		'DATE.UNTIL': 'Indtil (Dato)',
		'DATE.WEDNESDAY': 'Onsdag',
		'DAY.CURRENT': 'Nuværende dag',
		'DAY.NEXT': 'Næste dag',
		'DAY.PREVIOUS': 'Forrige dag',
		'DAY.SELECTED': 'Valgt dag',
		'DAYS': 'Dage',
		'DAY_ACTIVITIES': 'Dagsaktiviteter',
		'DEACTIVATE': 'Deaktivere',
		'DEACTIVATE.SELECTED': 'Deaktivere valgt',
		'DEADLINE': 'Frist',
		'DEADLINE.ADD': 'Tilføj frist',
		'DEADLINE.ADD.SUCCESS': 'Frist succesfuldt oprettet!',
		'DEADLINE.DELETE.SUCCESS': 'Frist succesfuldt slettet!',
		'DEADLINE.DONE': 'Udfør',
		'DEADLINE.DUE': 'Udløbet frist',
		'DEADLINE.DUE_IN_AT': 'Forfalder i/på',
		'DEADLINE.EDIT': 'Rediger deadline',
		'DEADLINE.EDIT.SUCCESS': 'Frist succesfuldt redigeret!',
		'DEADLINE.IS_CLOSE': 'Denne frist udløber snart',
		'DEADLINE.IS_OVERDUE': 'Denne frist er forfalden',
		'DEADLINE.OPEN': 'Åbn',
		'DEADLINE.PROCESS.SUCCESS': 'Deadline behandlet med succes',
		'DEADLINE.PROCESSED': 'Behandlet',
		'DEADLINE.PROCESSED.SUCCESS': 'Frist succesfuldt redigeret!',
		'DEADLINE.WARN': 'Forestående frist',
		'DEADLINES': 'Frister',
		'DEADLINES.NO': 'Ingen frister',
		'DEFINE_ROLE': 'Definer rolle',
		'DELETE': 'Fjern ISOTaskData',
		'DELETE.SELECTED': 'Slet valgte',
		'DELETED': 'Slettet',
		'DESCRIPTION': 'Betegnelse',
		'DIAGRAM': 'Diagram',
		'DISPLAY': 'Vis',
		'DISPLAY_TRACK': 'Vis kørespor',
		'DISTANCE': 'Afstand',
		'DISTANCE.TOTAL': 'Samlet strækning',
		'DISTANCE.WORKED': 'Bearbejdet afstand',
		'DOWNLOAD': 'Download',
		'DRIVER': 'Chauffør',
		'DRIVER.EDIT': 'Rediger driver',
		'DRIVER.FIXED': 'Fast driver',
		'DRIVER.NO': 'Ingen chauffør',
		'DRIVER.REMOVE': 'Fjern driveren',
		'DRIVERS': 'Chauffører',
		'DRIVERS.ALL': 'Alle chauffører',
		'DRIVER_SCAN_DISABLED': 'Chauffør-Beacon scan inaktiv',
		'DURATION': 'Varighed',
		'DURATION.WORKED': 'Arbejdet varighed',
		'EDIT': 'Rediger',
		'EDIT.SELECTED': 'Rediger valgt',
		'EDIT_USER': 'Rediger bruger',
		'EMAIL': 'Kontakt e-mail',
		'EMAIL.ACTIVATE': 'Aktivere e-mail',
		'EMAIL.ACTIVATE.CODE': 'Aktiveringskode',
		'EMAIL.ACTIVATE.EXPLANATION': 'Når du har ændret din e-mail-adresse, modtager du en frigivelseskode på din nye e-mail-adresse.',
		'EMAIL.CHANGE': 'Ændre e-mail',
		'EMAIL.CHANGE.SUCCESS': 'Din e-mail-adresse er succesfuldt blevet ændret',
		'EMAIL.CONFIRM': 'Bekræft e-mail',
		'EMAIL.CURRENT': 'Nuværende e-mail-adresse',
		'EMAIL.INVALID': 'E-mail',
		'EMAIL.NEW': 'Ny e-mail-adresse',
		'EMAIL.NO_MATCH': 'E-mails stemmer ikke overens',
		'EMPLOYEE': 'Medarbejder',
		'EMPLOYEE.ACTIVATE.QUESTION': 'Ønsker du virkelig at aktivere medarbejderen?',
		'EMPLOYEE.ADD': 'Tilføj medarbejder',
		'EMPLOYEE.ADD.SUCCESS': 'Medarbejder tilføjet',
		'EMPLOYEE.CREATE': 'Opret medarbejder',
		'EMPLOYEE.CREATE.SUCCESS': 'Medarbejder oprettet',
		'EMPLOYEE.DEACTIVATE.QUESTION': 'Er du sikker på, at medarbejderen skal deaktiveres?',
		'EMPLOYEE.DELETE.QUESTION': 'Er du sikker på, at medarbejderen skal fjernes?',
		'EMPLOYEE.EDIT': 'Rediger medarbejder',
		'EMPLOYEE.EDIT.SUCCESS': 'Medarbejder succesfuldt redigeret',
		'EMPLOYEE.ROLE': 'Medarbejderens rolle',
		'EMPLOYEE.ROLE_OF': 'Medarbejderens rolle',
		'EMPLOYEES': 'Medarbejdere',
		'EMPLOYEES.ACTIVATE.QUESTION': 'Vil du virkelig aktivere medarbejderne?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Medarbejdere aktiveret med succes',
		'EMPLOYEES.ALL': 'Alle medarbejdere',
		'EMPLOYEES.DEACTIVATE.FAILURE': 'Nogle af de ansatte kunne ikke deaktiveres.',
		'EMPLOYEES.DEACTIVATE.QUESTION': 'Ønsker du virkelig at deaktivere de valgte medarbejdere?',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'Medarbejdere er blevet deaktiveret',
		'EMPLOYEES.DELETE.FAILURE': 'Nogle af de ansatte kunne ikke slettes.',
		'EMPLOYEES.DELETE.QUESTION': 'Ønsker du virkelig at slette de valgte medarbejdere',
		'EMPLOYEES.DELETE.SUCCESS': 'Medarbejdere slettet',
		'EMPLOYEES.MANAGEMENT': 'Medarbejderadministration',
		'EMPLOYEES.NO': 'Der findes ingen inaktive medarbejdere',
		'EMPLOYEES.NOT_SELECTED': 'Ingen medarbejdere valgt',
		'EMPLOYEES.SELECTED': 'Udvalgte medarbejdere',
		'EMPLOYER.NO': 'Vælg først en arbejdsgiver!',
		'EMPLOYER.NOT_SELECTED': 'Vælg først en arbejdsgiver!',
		'EMPLOYES.NO': 'Ingen ansatte',
		'END_DRAW_MODE': 'Tegnemodus afsluttet!',
		'ENTERPRISE': 'Virksomhed',
		'ENTERPRISE.ADD': 'Tilføj bedrift',
		'ENTERPRISE.ADD.SUCCESS': 'Succesfuldt tilføjet til bedrift.',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Indtast access token til den bedrift, som skal tilføjes.',
		'ENTERPRISE.NAME': 'Driftsnavn',
		'ENTERPRISE.NOT_SELECTED': 'Vælg først en bedrift',
		'ENTERPRISE.OF': 'Bedrift fra:',
		'ENTERPRISE.SETTINGS': 'Indstillinger',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'Virksomhedskonfigurationen er blevet opdateret med succes',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Maskiner synkroniseret med succes',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Medarbejder licenser',
		'ENTERPRISE_LICENSE.LICENSE': 'Licens',
		'ENTERPRISE_LICENSE.MACHINE': 'Maskinlicens',
		'ENTERPRISE_LICENSE.MACHINES': 'Licenser til maskiner',
		'ENTERPRISE_MIN': 'Driftsnavn skal indeholde mindst 3 tegn.',
		'ENTERPRISE_NAME_REQUIRED': 'Driftsnavn påkrævet',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Tilføj bedrift',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'Licens udløbet',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Rekvirer test-konto',
		'ENTERPRISE_STATISTICS': 'Bedriftsstatistikker',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Omkostningsdiagram',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'Procesopdeling',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'Alle',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Arbejde / transport',
		'ENUM.ACCOUNTING_MODE.AVG': 'Gennemsnit',
		'ENUM.ACCOUNTING_MODE.MAX': 'Maksimum',
		'ENUM.ACCOUNTING_MODE.MED': 'Median',
		'ENUM.ACCOUNTING_MODE.MIN': 'Minimum',
		'ENUM.ACCOUNTING_MODE.SUM': 'Sum',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Absolut difference',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Direkte',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': 'Negativ difference',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Positiv difference',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Tid aktiv',
		'ENUM.BEACONTYPE.BDrv': 'Beacon til fører',
		'ENUM.BEACONTYPE.BImpl': 'Implementere beacon',
		'ENUM.CAN_IDENTIFIER.A1': 'Analog 1',
		'ENUM.CAN_IDENTIFIER.A2': 'Analog 2',
		'ENUM.CAN_IDENTIFIER.A3': 'Analog 3',
		'ENUM.CAN_IDENTIFIER.A4': 'Analog 4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'AUX0 eksternt flow',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': ' AUX0 retracting flow ',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': ' AUX1 external flow ',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'AUX1 retracting flow ',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': ' AUX2 external flow ',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': ' AUX2 retracting flow ',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': ' AUX3 external flow ',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': ' AUX3 retracting flow ',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'AUX4 external flow ',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': ' AUX4 retracting flow ',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'Vinkel 1 gennemsnit',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'Vinkel 1 maks.',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'Vinkel 1 min',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'Vinkel 2 gennemsnit',
		'ENUM.CAN_IDENTIFIER.Ag2max': 'Vinkel 2 maks.',
		'ENUM.CAN_IDENTIFIER.Ag2min': 'Vinkel 2 min',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'Vinkel 3 gennemsnit',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'Vinkel 3 maks.',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'Vinkel 3 min',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'Udbragt syre',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'Udbragte additiver',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'Udbragt gylle',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Akselvægt 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Akselvægt 2',
		'ENUM.CAN_IDENTIFIER.C1': 'Tæller 1',
		'ENUM.CAN_IDENTIFIER.C2': 'Tæller 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Halmsnitter',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': 'Circ_1_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': 'Circ_2A_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Circ_2B_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': 'Circ_3_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': 'Circ_4_Stat',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Slip kobling',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Guide til skærer',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'Guide til skærer (P) ',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Skæreværksposition',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Skærerbord',
		'ENUM.CAN_IDENTIFIER.D1': 'Digital 1',
		'ENUM.CAN_IDENTIFIER.D2': 'Digital 2',
		'ENUM.CAN_IDENTIFIER.D3': 'Digital 3',
		'ENUM.CAN_IDENTIFIER.D4': 'Digital 4',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Kørevalggreb',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'AdBlue-niveau',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Tankfyldningsniveau',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Brændstofforbrug',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': 'Motoromdrejningstal',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Motordrejemoment',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Hejseværkstilling foran',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'Kraftudtagsaksel foran aktiv',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'Kraftudtagsakslernes hastighed foran',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Field_Switch',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': 'Field_Switch2',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Trækkraft foran',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Nominel trækkraft foran',
		'ENUM.CAN_IDENTIFIER.GB_Dir': 'Retning (jordbaseret)',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Hastighed jord',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Hastighed GPS',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Valgt gear',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Korntransport position',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Korntank fyldningsniveau',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': 'HySt_Dir',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': 'HySt_Mod',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Implementer arbejdsstatus',
		'ENUM.CAN_IDENTIFIER.JbSta': 'Job aktiv',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Motor (venstre) hastighed',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Motor (venstre) drejningsmoment',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Motorens (højre) hastighed',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Motor (højre) drejningsmoment',
		'ENUM.CAN_IDENTIFIER.NO_XTR': 'ingen værdi',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SyreN: NUE absolut',
		'ENUM.CAN_IDENTIFIER.NUE_rel': 'SyreN: NUE-relativ',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'Gylle pH-værdi',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'PTO_Switch',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'PTO_Switch1',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'PTO_Switch2',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': ' PTO_Switch3 ',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'Nærhedssensor',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Hejseværkstilling bagved',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'Kraftudtagsaksel bagved aktiv',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'Kraftudtagsakslernes hastighed bagved',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Trækkraft bagved',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Nominel trækkraft bagved',
		'ENUM.CAN_IDENTIFIER.Roll': 'Rollrate',
		'ENUM.CAN_IDENTIFIER.Sli': 'Slip',
		'ENUM.CAN_IDENTIFIER.Spe': 'Hastighed',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Halmsnitter position',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Tærsketromle',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Dæktryk til venstre A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Dæktryk til venstre A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'Dæktryk til højre A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'Dæktryk til højre A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': 'UnlAuger_Act',
		'ENUM.CAN_IDENTIFIER.WB_Dir': 'Retning (hjulbaseret)',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Hastighed hjul',
		'ENUM.CAN_IDENTIFIER.Xacc': 'Acceleration X',
		'ENUM.CAN_IDENTIFIER.Yacc': 'Acceleration Y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'Giringsudsving',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Faktisk udbytte',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Udbytte fugtighed',
		'ENUM.CAN_IDENTIFIER.Zacc': 'Acceleration Z',
		'ENUM.COSTPER.h': 'h',
		'ENUM.COSTPER.ha': 'ha',
		'ENUM.COSTPER.km': 'km',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': '$',
		'ENUM.CURRENCY.EURO': '€',
		'ENUM.CURRENCY.GBP': ' £ ',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Administrator',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Consultant',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Disponent',
		'ENUM.EMPLOYEEROLE.DRIVER': 'Chauffører',
		'ENUM.EVENTTYPE.COMMENT': 'Meddelelse',
		'ENUM.EVENTTYPE.CT': 'Tæller',
		'ENUM.EVENTTYPE.CT_RS': 'Tæller nulstillet',
		'ENUM.EVENTTYPE.CUSTOMER': 'Kunde',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Medarbejder kobler påhængsredskab',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'Medarbejder betræder mark',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'Medarbejder betræder traktor',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'Medarbejder forlader mark',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'Medarbejder forlader traktor',
		'ENUM.EVENTTYPE.EMPL_P_START': 'Medarbejder holder pause',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'Medarbejder afslutter pause',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Medarbejder frakobler påhængsredskab',
		'ENUM.EVENTTYPE.EMPL_W_START': 'Medarbejder starter arbejde',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'Medarbejder afslutter arbejde',
		'ENUM.EVENTTYPE.GTO70': 'Korntank fuld',
		'ENUM.EVENTTYPE.JOBINFO': 'Job-info',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Job pause',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Fortsæt job',
		'ENUM.EVENTTYPE.JOB_START': 'Job start',
		'ENUM.EVENTTYPE.JOB_STOP': 'Job slut',
		'ENUM.EVENTTYPE.L_IMPL': 'Medarbejder læsser påhængsredskab',
		'ENUM.EVENTTYPE.REFUELING': 'Påfyldning',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'SyreN-kunde',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'SyreN-felt',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'SyreN gylle type',
		'ENUM.EVENTTYPE.T2_ON': 'Adapter online',
		'ENUM.EVENTTYPE.UL_IMPL': 'Medarbejder losser påhængsredskab',
		'ENUM.EVENTTYPE.WEATHER': 'Vejr',
		'ENUM.EVENTTYPE.WEIGHING': 'Vejning',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Vejning (tara)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'oprettet',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'på maskine',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'færdig',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Arkiveret',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Slettes',
		'ENUM.JOBGENERATIONSTATE.EDT': 'Redigeres',
		'ENUM.JOBGENERATIONSTATE.GEN': 'Generer',
		'ENUM.JOBGENERATIONSTATE.MER': 'Sammenføres',
		'ENUM.JOBGENERATIONSTATE.QUE': 'Queued',
		'ENUM.JOBGENERATIONSTATE.READY': 'OK',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'Regenerer',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Skilles',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Opdatering af',
		'ENUM.LOCATIONTYPE.FARM': 'Gård',
		'ENUM.LOCATIONTYPE.FUEL': 'Tankstation',
		'ENUM.LOCATIONTYPE.OTHERS': 'Andre',
		'ENUM.LOCATIONTYPE.STABLE': 'Stald',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Vægt',
		'ENUM.MACHINETYPE.COMBINE': 'Mejetærsker',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Gravemaskine',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Grønthøster',
		'ENUM.MACHINETYPE.MISC': 'Andet',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'Selvkørende maskine',
		'ENUM.MACHINETYPE.SYREN': 'Syren',
		'ENUM.MACHINETYPE.TELEHANDLER': 'Teleskoplæsser',
		'ENUM.MACHINETYPE.TRACTOR': 'Traktor',
		'ENUM.MACHINETYPE.TRUCK': 'Lastbil',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Hjullæsser',
		'ENUM.MSGUNIT.-': '-',
		'ENUM.MSGUNIT.AXLES': 'Aksler',
		'ENUM.MSGUNIT.CUBIC_M': 'm³',
		'ENUM.MSGUNIT.DOLLAR': '$',
		'ENUM.MSGUNIT.EURO': '€',
		'ENUM.MSGUNIT.KG': 'kg',
		'ENUM.MSGUNIT.LITER': 'l',
		'ENUM.MSGUNIT.TONS': 't',
		'ENUM.MSGUNIT.h': 'h',
		'ENUM.MSGUNIT.ha': 'ha',
		'ENUM.MSGUNIT.km': 'km',
		'ENUM.ONLY_ON_STATE.A': 'Altid',
		'ENUM.ONLY_ON_STATE.F': 'Mark',
		'ENUM.ONLY_ON_STATE.L': 'Sted',
		'ENUM.ONLY_ON_STATE.R': 'Vej',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amatron 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': 'A_XY',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': 'C_S2034',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Type 1 (skriver på USB-stick)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Type 2 (skriver ikke på USB-nøgle)',
		'ENUM.TRANSPORTUNIT.-': '-',
		'ENUM.TRANSPORTUNIT.AXLES': 'Aksler',
		'ENUM.TRANSPORTUNIT.BALE': 'Bale',
		'ENUM.TRANSPORTUNIT.CUBIC_M': 'm³',
		'ENUM.TRANSPORTUNIT.KG': 'kg',
		'ENUM.TRANSPORTUNIT.LITER': 'l',
		'ENUM.TRANSPORTUNIT.TONS': 't',
		'ENUM.USERROLE.ADMIN': 'Administrator',
		'ENUM.USERROLE.ENTERPRISE': 'Bedrift',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Tech. Saleforce',
		'ENUM.USERROLE.TRAN': 'Oversættelse',
		'ENUM.USERROLE.USER': 'Bruger',
		'ENUM.USERROLE.USER_EMPL': 'Bruger (virksomhed)',
		'ENUM.USERSTATE.ACTIVE': 'Aktiv',
		'ENUM.USERSTATE.DISABLED': 'Spærret',
		'ENUM.USERSTATE.NOT_VERIFIED': 'Ikke verificeret',
		'ENUM.WORKSTATE.DRIVING': 'Kør',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Ventetid kørsel',
		'ENUM.WORKSTATE.MISC_FIELD': 'Ventetid mark',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Korntank fuld',
		'ENUM.WORKSTATE.MISC_ROAD': 'Ventetid vej',
		'ENUM.WORKSTATE.PAUSE': 'Pause',
		'ENUM.WORKSTATE.PREPARATION': 'Forberedelse',
		'ENUM.WORKSTATE.ROAD': 'Vej',
		'ENUM.WORKSTATE.THRESHING': 'Tærske',
		'ENUM.WORKSTATE.THRESHING_U': 'Aflæsning under tærskning',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Tærskning med halmsnitter',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Aflæsning under tærskning med halmhugger',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Læsset',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Vent læsset',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Læsning',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Ulæsset',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Vent ulæsset',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Losning',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Losning under tærskning',
		'ENUM.WORKSTATE.TURNING': 'Vende',
		'ENUM.WORKSTATE.UNDEFINED': 'udefineret',
		'ENUM.WORKSTATE.WORKING': 'Arbejde',
		'ENUM.WORKSTATE.WORKING_MISC': 'Ventetid arbejde',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'Du skal tilføje en arbejdsgiver',
		'ENTERPRISE.ADDED.SUCCESS': 'Virksomhed tilføjet med succes',
		'ERROR.NO_GPS_DATA': 'Der findes ingen GPS-data for den valgte maskine',
		'ERROR_MESSAGE': 'Fejlmelding',
		'EVENTS': 'Hændelser',
		'EVENTS.FIELD': 'Begivenheder på banen',
		'EVENTS.NO': 'Ingen begivenheder',
		'EXA_ADAPTERS': 'Adapter',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Aktiver adapter i Agrirouter',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Fjern adapter fra Agrirouter',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Adapter aktiveret i Agrirouter',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': 'Adapter fjernet fra Agrirouter',
		'EXCEPTION.1': 'Intern fejl',
		'EXCEPTION.100': 'Enum ugyldig',
		'EXCEPTION.1000': 'Brugernavn er tomt',
		'EXCEPTION.10000': 'Filenavnet er tomt',
		'EXCEPTION.10001': 'Data er tomme',
		'EXCEPTION.10002': 'FormatType ugyldig',
		'EXCEPTION.10003': 'DataRequestType ugyldig',
		'EXCEPTION.10004': 'Ingen rådata',
		'EXCEPTION.1001': 'Brugernavnets længde er under minimumslængden',
		'EXCEPTION.1002': 'Brugernavn er allerede optaget',
		'EXCEPTION.1003': 'E-mail-adresse er ugyldig',
		'EXCEPTION.1004': 'E-mail-adressen er allerede optaget',
		'EXCEPTION.1005': 'Adgangskodelængden er under minimumslængden',
		'EXCEPTION.1007': 'Verifikationskode ugyldig',
		'EXCEPTION.1008': 'Brugernavn eller E-mail',
		'EXCEPTION.101': 'Medarbejderens rolle er ugyldig',
		'EXCEPTION.1011': 'Brugeren findes ikke',
		'EXCEPTION.1012': 'Brugeren er slettet',
		'EXCEPTION.1013': 'Brugeren er inaktiv',
		'EXCEPTION.1014': 'Brugeren er blokeret',
		'EXCEPTION.1015': 'Brugeren er ikke aktiveret',
		'EXCEPTION.1016': 'Brugeren er en virksomhedskonto',
		'EXCEPTION.102': 'Valuta ugyldig',
		'EXCEPTION.1020': 'Brugeren findes allerede',
		'EXCEPTION.1021': 'E-mail-adresse allerede optaget',
		'EXCEPTION.1022': 'E-mail-adressen er ikke ændret',
		'EXCEPTION.1023': 'Aktuel adgangskode stemmer ikke overens',
		'EXCEPTION.1024': 'Brugernavn er allerede optaget',
		'EXCEPTION.1025': 'Bruger og kode stemmer ikke overens',
		'EXCEPTION.1026': 'Brugernavn eller E-mail',
		'EXCEPTION.1027': 'Bruger allerede aktiveret',
		'EXCEPTION.1028': 'Forbudt for medarbejderkonti oprettet for en virksomhed',
		'EXCEPTION.103': 'Transportenhed ugyldig',
		'EXCEPTION.104': 'Placeringstype ugyldig',
		'EXCEPTION.105': 'Omkostningsenhed ugyldig',
		'EXCEPTION.106': 'Enhed ugyldig',
		'EXCEPTION.107': 'Maskintype ugyldig',
		'EXCEPTION.108': 'Medarbejderstatus ugyldig',
		'EXCEPTION.11000': 'Type ugyldig',
		'EXCEPTION.12000': 'Type ugyldig',
		'EXCEPTION.12002': 'Seriel er tom',
		'EXCEPTION.12003': 'Arbejdstilstand ugyldig',
		'EXCEPTION.12004': 'Jobstatus ugyldig',
		'EXCEPTION.12006': 'Ingen T2-konfiguration',
		'EXCEPTION.12007': 'MAC er tom',
		'EXCEPTION.12008': 'MAC ugyldig',
		'EXCEPTION.12009': 'Adapter findes allerede',
		'EXCEPTION.12010': 'Adaptertype er ugyldig',
		'EXCEPTION.15000': 'Starttidspunktet er tomt eller ligger i fremtiden',
		'EXCEPTION.15001': 'Stoptidspunktet er tomt eller i fremtiden',
		'EXCEPTION.15002': 'Stoptidspunktet er lig med eller før starttidspunktet',
		'EXCEPTION.15003': 'Ikke i stand til at generere SILO-pakken - ingen rådata',
		'EXCEPTION.15004': 'Rå data for gamle',
		'EXCEPTION.16000': 'Navn er tomt',
		'EXCEPTION.16001': 'Den tildelte kunde findes ikke',
		'EXCEPTION.16002': 'Markeringslisten er tom',
		'EXCEPTION.16003': 'Markørlisten skal indeholde mindst tre markører',
		'EXCEPTION.16004': 'Området er tomt',
		'EXCEPTION.16005': 'Mærketype ugyldig',
		'EXCEPTION.16006': 'Feltet er ikke indeholdt i jobbet',
		'EXCEPTION.16007': 'Rasterstørrelsen er større end halvdelen af feltets højde og bredde',
		'EXCEPTION.16008': 'Ingen data til interpolering',
		'EXCEPTION.16009': 'Alle data indeholder den samme værdi',
		'EXCEPTION.17000': 'Navn er tomt',
		'EXCEPTION.17001': 'Kontaktperson er tom',
		'EXCEPTION.17002': 'Telefonen er tom',
		'EXCEPTION.17003': 'E-mail-adressen er tom',
		'EXCEPTION.17004': 'E-mail-adresse er ugyldig',
		'EXCEPTION.17005': 'Adressen er tom',
		'EXCEPTION.17006': 'Postnummer er tomt',
		'EXCEPTION.17007': 'Byen er tom',
		'EXCEPTION.17008': 'Farve ugyldig ((AA)RRGGBB)',
		'EXCEPTION.18000': 'Type ugyldig',
		'EXCEPTION.19001': 'Type ugyldig',
		'EXCEPTION.19002': 'MAC er tom',
		'EXCEPTION.19003': 'MAC ugyldig',
		'EXCEPTION.19004': 'Effekten er mindre end nul',
		'EXCEPTION.19007': 'Medarbejder er tom',
		'EXCEPTION.19008': 'Beacon er ikke et implementeringsbeacon',
		'EXCEPTION.19009': 'Beacon er ikke et driverbeacon',
		'EXCEPTION.2': 'Duplikatpost',
		'EXCEPTION.200': 'Fejl ved parsing af Json-objekttype',
		'EXCEPTION.2000': 'Oprettelse af verifikationskode mislykkedes',
		'EXCEPTION.20000': 'Mængden af rådata er for lav',
		'EXCEPTION.20001': 'Oprettelse af arkivfil mislykkedes',
		'EXCEPTION.20002': 'Indlæsning af arkivfil mislykkedes',
		'EXCEPTION.2001': 'Verifikationskode findes ikke',
		'EXCEPTION.2002': 'Bekræftelseskode ugyldig',
		'EXCEPTION.201': 'Fejl ved at skrive objekttype til Json',
		'EXCEPTION.21000': 'Virksomhedsnavnet er tomt',
		'EXCEPTION.21001': 'Virksomhedsnavn allerede optaget',
		'EXCEPTION.21002': 'Virksomhedsnavnets længde er under minimumslængden',
		'EXCEPTION.21003': 'Virksomhedens e-mail-adresse er ugyldig',
		'EXCEPTION.21004': 'Adgangstoken findes allerede',
		'EXCEPTION.21005': 'Virksomheden er slettet',
		'EXCEPTION.21006': 'Virksomheden er deaktiveret',
		'EXCEPTION.21007': 'Virksomheden er blokeret',
		'EXCEPTION.21008': 'Virksomhedstype ugyldig',
		'EXCEPTION.22000': 'Ingen job at tilføje',
		'EXCEPTION.22001': 'Ingen job ændret',
		'EXCEPTION.23000': 'Enterprise ikke om bord',
		'EXCEPTION.23001': 'Enterprise er allerede om bord',
		'EXCEPTION.23002': 'Adapter ikke indbygget',
		'EXCEPTION.23003': 'Adapter allerede indbygget',
		'EXCEPTION.23004': 'Kunne ikke onboard adapter',
		'EXCEPTION.23005': 'Kunne ikke genindkoble adapteren',
		'EXCEPTION.23006': 'Kunne ikke afmontere adapter',
		'EXCEPTION.23007': 'Publicering af vCU-funktioner mislykkedes',
		'EXCEPTION.23008': 'Publicering af vCU-data mislykkedes',
		'EXCEPTION.23009': 'Publicering af vCU-enhedsbeskrivelse mislykkedes',
		'EXCEPTION.23010': 'Udgivelse af virksomhedsfunktioner mislykkedes',
		'EXCEPTION.23011': 'Agrirouter certifikatfejl! Har du fornyet Agrirouter-forbindelsen?',
		'EXCEPTION.24000': 'Virksomhedsnavnet er tomt',
		'EXCEPTION.24001': 'Virksomhedsnavn allerede optaget',
		'EXCEPTION.24002': 'Virksomhedsnavnets længde er under minimumslængden',
		'EXCEPTION.24003': 'Virksomhedens e-mail-adresse er ugyldig',
		'EXCEPTION.24004': 'Adgangstoken findes allerede',
		'EXCEPTION.24005': 'Virksomheden er slettet',
		'EXCEPTION.24006': 'Virksomheden er deaktiveret',
		'EXCEPTION.24007': 'Virksomheden er blokeret',
		'EXCEPTION.25000': 'Funktionen er ikke tilgængelig for den valgte partner',
		'EXCEPTION.25001': 'Synkronisering af felter mislykkedes',
		'EXCEPTION.25002': 'Synkronisering af maskiner mislykkedes',
		'EXCEPTION.25003': 'Synkronisering af implementer mislykkedes',
		'EXCEPTION.25004': 'Få maskinen mislykkedes',
		'EXCEPTION.25005': 'Oprettelse af maskine mislykkedes',
		'EXCEPTION.25006': 'Opdatering af maskine mislykkedes',
		'EXCEPTION.25007': 'Sletning af maskine mislykkedes',
		'EXCEPTION.25008': 'Det lykkedes ikke at få implementeret',
		'EXCEPTION.25009': 'Oprettelse af implementering mislykkedes',
		'EXCEPTION.25010': 'Opdatering af implementet mislykkedes',
		'EXCEPTION.25011': 'Sletning af implement mislykkedes',
		'EXCEPTION.26000': 'Oprettelse af PDF-fil mislykkedes',
		'EXCEPTION.26001': 'Det valgte job er ikke et SyreN-aktiveret job',
		'EXCEPTION.27000': 'Maskinen understøtter ikke TaskData-filer',
		'EXCEPTION.27001': 'Oprettelse af TaskData-fil mislykkedes',
		'EXCEPTION.27002': 'Indlæsning af TaskData-fil mislykkedes',
		'EXCEPTION.27003': 'Maskinen har ingen tildelt adapter',
		'EXCEPTION.27004': 'Navn er tomt',
		'EXCEPTION.27005': 'Planlagt dato er tom',
		'EXCEPTION.27006': 'Den planlagte dato ligger ikke i fremtiden',
		'EXCEPTION.27007': 'Staten er tom',
		'EXCEPTION.27008': 'Filen er tom',
		'EXCEPTION.27009': 'Filenavnet er tomt',
		'EXCEPTION.27010': 'Dato er tom',
		'EXCEPTION.27011': 'Datoen ligger ikke i fremtiden',
		'EXCEPTION.27012': 'Størrelsen er under en',
		'EXCEPTION.27013': 'TaskData-operationen er ikke tilgængelig i den aktuelle tilstand',
		'EXCEPTION.27014': 'Filnavnet er allerede optaget',
		'EXCEPTION.27015': 'Ingen åbne opgaver',
		'EXCEPTION.27016': 'Kun én ikke-downloadet TaskData-fil er tilladt',
		'EXCEPTION.28001': 'Filtype ikke understøttet',
		'EXCEPTION.29000': 'Opdatering ikke tilladt (allerede behandlet)',
		'EXCEPTION.29001': 'Ingen maskine eller redskab angivet',
		'EXCEPTION.29002': 'Kun maskine ELLER redskab tilladt',
		'EXCEPTION.29003': 'Basisværdien skal være større end nul',
		'EXCEPTION.29004': 'advarselsværdien skal være større end nul',
		'EXCEPTION.29005': 'Den skyldige værdi skal være større end nul',
		'EXCEPTION.29006': 'Forfaldsinterval skal være større end varslingsinterval',
		'EXCEPTION.3000': 'Loginoplysninger er ugyldige',
		'EXCEPTION.3001': 'Kontoen er spærret',
		'EXCEPTION.3002': 'Kontoen er ikke aktiveret',
		'EXCEPTION.3003': 'Sessionen er udløbet - Log venligst ind igen',
		'EXCEPTION.3004': 'En anden bruger er logget ind med den samme konto',
		'EXCEPTION.31000': 'App understøttes ikke',
		'EXCEPTION.4000': 'Make er tom',
		'EXCEPTION.4001': 'Modellen er tom',
		'EXCEPTION.4002': 'Året skal være mere end 1950 og ikke i fremtiden',
		'EXCEPTION.4003': 'Omkostningerne er mindre end eller lig med nul',
		'EXCEPTION.4004': 'Driftstimer er mindre end nul',
		'EXCEPTION.4005': 'Kilometerstand er mindre end nul',
		'EXCEPTION.4007': 'Arbejdsbredden er mindre end nul',
		'EXCEPTION.4008': 'Farve ugyldig ((AA)RRGGBB)',
		'EXCEPTION.4009': 'XtrCanValuesConfig ugyldig',
		'EXCEPTION.401': 'Uautoriseret',
		'EXCEPTION.4010': 'For mange konfigurationsværdier',
		'EXCEPTION.4011': 'Dynamisk konfiguration ugyldig',
		'EXCEPTION.4012': 'Maskintype er ikke Traktor',
		'EXCEPTION.4013': 'Det maksimale antal licenser er taget',
		'EXCEPTION.4014': 'Datoen ligger i fremtiden',
		'EXCEPTION.4015': 'Hastighedsoverskridelse er ugyldig',
		'EXCEPTION.403': 'Forbudt',
		'EXCEPTION.450': 'Kommando fejl',
		'EXCEPTION.451': 'Ingen licens påkrævet',
		'EXCEPTION.452': 'Filterparameter ugyldig',
		'EXCEPTION.5000': 'Make er tom',
		'EXCEPTION.5001': 'Modellen er tom',
		'EXCEPTION.5002': 'Året skal være mere end 1950 og ikke i fremtiden',
		'EXCEPTION.5003': 'Type1 er tom',
		'EXCEPTION.5004': 'Type2 ugyldig',
		'EXCEPTION.5005': 'Omkostningerne er mindre end eller lig med nul',
		'EXCEPTION.5006': 'Arbejdsbredden er mindre end nul',
		'EXCEPTION.5007': 'Transportværdien er mindre end nul',
		'EXCEPTION.5008': 'Transportenhed ugyldig',
		'EXCEPTION.5009': 'Type3 ugyldig',
		'EXCEPTION.5010': 'Type kombination er ugyldig',
		'EXCEPTION.5011': 'Regnskabsidentifikator ugyldig',
		'EXCEPTION.6000': 'Type ugyldig',
		'EXCEPTION.6001': 'Radius er tom eller under nul',
		'EXCEPTION.6002': 'Navn er tomt',
		'EXCEPTION.6003': 'Markeringslisten er tom',
		'EXCEPTION.6004': 'Markørlisten skal indeholde mindst tre markører',
		'EXCEPTION.6005': 'Mærketype ugyldig',
		'EXCEPTION.6006': 'Vejningstype ugyldig',
		'EXCEPTION.700': 'VarName ugyldig',
		'EXCEPTION.7001': 'Kontoen findes ikke',
		'EXCEPTION.7002': 'Kontoen er spærret',
		'EXCEPTION.701': 'Formel ugyldig',
		'EXCEPTION.702': 'CAN ID navn er ugyldigt',
		'EXCEPTION.703': 'Betingelse ugyldig',
		'EXCEPTION.704': 'Variabelnavn Ugyldigt',
		'EXCEPTION.705': 'Parameteren for arbejdstilstand er ugyldig',
		'EXCEPTION.706': 'Arbejdstilstand ugyldig for implementtype',
		'EXCEPTION.707': 'Oprettelse af fil mislykkedes',
		'EXCEPTION.800': 'ConfigValue navn ugyldigt',
		'EXCEPTION.8000': 'Arbejdsgiver er tom',
		'EXCEPTION.8001': 'Medarbejder er tom',
		'EXCEPTION.8002': 'Arbejdstager ikke fundet for arbejdsgiver',
		'EXCEPTION.8003': 'Omkostninger mindre end nul',
    'EXCEPTION.8004': 'Jumlah maksimum lisénsi pamaké nu dicokot',
		'EXCEPTION.8005': 'Ikke din arbejdsgiver',
		'EXCEPTION.8006': 'Medarbejder findes allerede',
		'EXCEPTION.8007': 'Adgangstoken er tomt',
		'EXCEPTION.8008': 'Adgangstoken ugyldigt',
		'EXCEPTION.8009': 'Der skal være mindst én administrator i en virksomhed',
		'EXCEPTION.8010': 'Brugeren kan kun forbindes med den virksomhed, der har oprettet brugeren',
		'EXCEPTION.900': 'Findes ikke',
		'EXCEPTION.9000': 'Starttidspunktet er tomt eller ligger i fremtiden',
		'EXCEPTION.9001': 'Stoptidspunktet er tomt eller i fremtiden',
		'EXCEPTION.9002': 'Stoptidspunktet er lig med eller mindre end starttidspunktet',
		'EXCEPTION.9003': 'Chaufføren er ikke ansat hos arbejdsgiveren',
		'EXCEPTION.9004': 'Implement tilhører ikke jobindehaveren',
		'EXCEPTION.9005': 'Type1 ugyldig',
		'EXCEPTION.9006': 'Type2 ugyldig',
		'EXCEPTION.9007': 'Type3 ugyldig',
		'EXCEPTION.9008': 'Ikke i stand til at generere jobbet - ingen rådata',
		'EXCEPTION.9009': 'Ejeren af maskinen svarer ikke til ejeren af redskabet',
		'EXCEPTION.901': 'Findes allerede',
		'EXCEPTION.9010': 'Job findes allerede',
		'EXCEPTION.9012': 'Jobbet er ikke klar',
		'EXCEPTION.9013': 'Job er markeret til sletning',
		'EXCEPTION.9014': 'Job er arkiveret - Ingen JobLocations tilgængelige',
		'EXCEPTION.9015': 'Rå data for gamle',
		'EXCEPTION.9016': 'Mindst ét job er en del af en opgave',
		'EXCEPTION.9017': 'Jobs passer ikke sammen (maskine, driver og implement skal passe sammen)',
		'EXCEPTION.9018': 'Afstanden mellem jobbene er for stor',
		'EXCEPTION.9019': 'Mindst ét job er en del af en opgave',
		'EXCEPTION.902': 'Ejeren findes ikke',
		'EXCEPTION.9020': 'Ingen opdelingstider',
		'EXCEPTION.9021': 'Delingstidspunktet er ikke større end starttidspunktet og mindre end stoptidspunktet',
		'EXCEPTION.9022': 'Ingen job-id\'er til sammenlægning',
		'EXCEPTION.9023': 'Mindst to arbejdspladser kræves',
		'EXCEPTION.9024': 'Punkttætheden skal være større end nul og mindre end eller lig med et',
		'EXCEPTION.903': 'Objekt med id findes ikke',
		'EXCEPTION.904': 'Breddegrad uden for rækkevidde',
		'EXCEPTION.905': 'Længde uden for rækkevidde',
		'EXCEPTION.906': 'Ejeren matcher ikke',
		'EXCEPTION.907': 'Parameteren er tom',
		'EXCEPTION.99': 'Parameter ugyldig',
		'EXPORT': 'Eksportere det markerede job',
		'EXPORT.FILTERED_JOBS': 'Eksporter alle filtrerede job',
		'EXPORT.JOB_DETAILS': 'Eksport af joboplysninger',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Eksporter alle data for kunden i den valgte periode',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Eksporter alle operationer på felter i den valgte periode',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Eksporter alle operationer på steder i den valgte periode',
		'EXPORT.POINTS': 'Datapunkter',
		'EXPORT.POLYGONS': 'Polygoner',
		'EXPORT.RAW_DATA_AS_SILO': 'Eksporter rå data fra jobbet som SILO-fil',
		'EXPORT.SELECTED': 'Eksport valgt',
		'EXPORT.SELECT_DATA': 'Følgende data skal medtages i PDF-rapporten',
		'EXPORT.SELECT_PERIOD': 'Vælg den periode, der skal eksporteres',
		'FIELD': 'Mark',
		'FIELD.ADD': 'Tilføj mark',
		'FIELD.ADD.SUCCESS': 'Mark succesfuldt oprettet.',
		'FIELD.DEACTIVATE.QUESTION': 'Ønsker du virkelig at deaktivere feltet?',
		'FIELD.DEACTIVATE.SUCCESS': 'Felt deaktiveret med succes',
		'FIELD.DELETE.QUESTION': 'Skal det virkelig fjernes?:',
		'FIELD.DELETE.SUCCESS': 'Mark fjernet',
		'FIELD.DETAILS': 'Markdetaljer',
		'FIELD.DRAW.START': 'Tegn mark ind i kortet nu!',
		'FIELD.EDIT.SUCCESS': 'Markeringer succesfuldt tilpasset!',
		'FIELD.INTERPOLATE': 'Interpoler',
		'FIELD.INTERPOLATED_VALUES': 'Interpolerede værdier',
		'FIELD.INTERPOLATION': 'Interpolation',
		'FIELD.INTERPOLATION_SETTINGS': 'Indstillinger interpolation',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Fin',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'meget fin',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'Grov',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'Middel',
		'FIELD.NUMBER': 'Feltnummer',
		'FIELD.PROCESSED': 'Bearbejdede marker',
		'FIELDS': 'Marker',
		'FIELDS.ALL': 'Alle felter',
		'FIELDS.DEACTIVATE.FAILURE': 'Nogle af felterne kunne ikke deaktiveres.',
		'FIELDS.DEACTIVATE.QUESTION': 'Ønsker du virkelig at deaktivere felterne?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Felter deaktiveret med succes',
		'FIELDS.DELETE.FAILURE': 'Nogle af felterne kunne ikke slettes.',
		'FIELDS.DELETE.QUESTION': 'Ønsker du virkelig at slette de valgte felter?',
		'FIELDS.DELETE.SUCCESS': 'Felter er blevet slettet med succes',
		'FIELDS.EDIT': 'Rediger felter',
		'FIELDS.IMPORT': 'Importer marker',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': 'Ønsker du at tildele en kunde til de valgte felter?',
		'FIELDS.IMPORT.SHAPE': 'Vælg en SHAPE-fil.',
		'FIELDS.IMPORT.SUCCESS': 'Felter importeret med succes',
		'FIELDS.MANAGEMENT': 'Markadministration',
		'FIELDS.NO': 'Ingen marker blev bearbejdet med denne proces',
		'FIELDS.NOT_SELECTED': 'Ingen felter valgt',
		'FIELDS.REACTIVATE.FAILURE': 'Nogle af felterne kunne ikke genaktiveres.',
		'FIELDS.REACTIVATE.QUESTION': 'Vil du virkelig genaktivere de valgte felter?',
		'FIELDS.REACTIVATE.SUCCESS': 'Felter genaktiveret med succes',
		'FIELDS.SELECT': 'Vælg felter',
		'FIELDS.SELECTED': 'Mark(er) valgt',
		'FILE': 'Fil',
		'FILE.GENERATING': 'Filen bliver genereret og føjet til filhåndteringen om lidt.',
		'FILE.GENERATING.READY': 'En ny fil er klar til download',
		'FILE.MANAGER': 'Filhåndtering',
		'FILE.NO_FILES': 'Ingen eksisterende filer',
		'FILE.UPLOAD': 'Upload fil',
		'FILE_TRANSFER': 'ISOTaskData administration',
		'FILE_TRANSFER.ADD': 'Tilføj ISOTaskData',
		'FILE_TRANSFER.ADD.SUCCESS': 'ISOTaskData succesfuldt tilføjet',
		'FILE_TRANSFER.CREATE': 'Tilføj ISOTaskData',
		'FILE_TRANSFER.DELETE.QUESTION': 'Er du sikker på, at ISOTaskData skal fjernes?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'ISOTaskData succesfuldt fjernet',
		'FILE_TRANSFER.FINISHED_TASKS': 'Redigerede ordrer',
		'FILE_TRANSFER.NO': 'Ingen ISOTaskData',
		'FILE_TRANSFER.QUEUED_TASKS': 'Åbne ordrer',
		'FILTER': 'Filter',
		'FIRMWARE_VERSION': 'Firmware-version',
		'FIRSTNAME': 'Fornavn',
		'FORMS.FILE_TOO_LARGE': 'Filen er for stor.',
		'FORMS.NO_PASSWORD_MATCH': 'Adgangskoderne passer ikke sammen!',
		'FORMS.REQUIRED': 'Navnefeltet må ikke være tomt!',
    'FORMS.INVALID_EMAIL': 'Ugyldig email-adresse',
		'FORMULA': 'Formel påkrævet',
		'FUEL': 'Brændstof',
		'FUEL.CONSUMPTION': 'Brændstofforbrug',
		'FUEL.CONSUMPTION.AREA': 'Brændstofforbrug pr. areal',
		'FUEL.CONSUMPTION.AVERAGE': 'Diesel pr. time',
		'FUEL.CONSUMPTION.OVERALL': 'Samlet brændstofforbrug',
		'FUEL.CONSUMPTION.TOTAL': 'Dieselforbrug',
		'FUEL.COST': 'Brændstofomkostninger',
		'FUEL.LEVEL': 'Tankfyldningsniveau',
		'FUEL.PRICE_PER_LITER': 'Brændstofpris pr. liter',
		'FUEL.WARNING': 'Tankfyldning lav!',
		'GENERAL_INSPECTION': 'Generel inspektion',
		'GEOMETRIES.UPDATE': 'Opdater felter og placeringer',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'Alle underliggende data skal opdateres for at tildele dem korrekt efter tilføjelse af en ny geometri. Vil du opdatere dataene nu?',
		'GEOMETRY.CLICK_TO_SAVE': 'For at gemme, klik på geometrien.',
		'GPS': ' GPS ',
		'GPS.GPS': ' Internal GPS ',
		'GPS.LP': 'Sidste kendte position',
		'GPS.RTK': ' RTK ',
		'GPS.RTK_H': 'RTK (høj præcision)',
		'GPS.STATUS': 'GPS-status',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'For recording the machine track correctly you need to input the distance between the hitch (A) and the point of application of the implement (B). The distance is measured in cm.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'For recording the machine track correctly you need to input the distance between the GPS receiver (A) and the hitch of the machine (B). The distance is measured in cm.',
		'GPS_TO_HITCH_DISTANCE': 'Afstand mellem GPS og hitch',
		'HARDWARE': ' Hardware ',
		'HARDWARE.SETUP.PRINT_STICKER': 'Udskriv hardware-klistermærke',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Udskriv mærkat til pakken',
		'HARDWARE.SETUP.RESET_DEVICE': 'Nulstil enheden',
		'HARDWARE.SETUP.SET_SERIAL': 'Indstil seriel',
		'HELPER_MODEL_TEXT': 'Model i overensstemmelse med input',
		'HEADLAND.PASSES': 'Headland passes',
		'HINT_MARKERS.SHOW': 'Vis markører med tips',
		'HITCH_TO_APPLICATION_DISTANCE': 'Afstand mellem hitch og applikation',
		'HOME': 'Velkommen',
		'HOME.CONTACTREPLY1': 'Så ring til os på',
		'HOME.CONTACTREPLY2': 'eller send os en e-mail til',
		'HOME.INTRODUCTORY_VIDEOS': 'Indledende videoer',
		'HOME.NEWSINFO1': 'Alle nyheder og spændende informationer rundt om emnet flådestyring og køretøjssporing finder du på vores',
		'HOME.NEWSINFO2': 'eller på vores',
		'HOME.PROFILEEXPLANATION': 'Under \"Mein Profil\" (min profil) kan du tilpasse dine personlige data samt ændre din e-mail og dit password.',
		'HOME.QUESTIONSYSTEM': 'Har du spørgsmål til vores system?',
		'HOME.TITLE': 'Velkommen',
		'HOME.WELCOMEAREA': 'Velkommen i dit område!',
		'IDLE': 'Tomgang',
		'IGNORE': 'Ignorer',
		'IMPLEMENT': 'Påhængsredskab',
		'IMPLEMENT.ADD': 'Tilføj påhængsredskab',
		'IMPLEMENT.ADD.SUCCESS': 'Påhængsredskab succesfuldt tilføjet',
		'IMPLEMENT.CLASS': 'Apparatklasse',
		'IMPLEMENT.DELETE.QUESTION': 'Skal påhængsredskabet virkelig slettes?',
		'IMPLEMENT.DELETE.SUCCESS': 'Redskab/anhænger fjernet.',
		'IMPLEMENT.DETAILS': 'Påhængsredskabsdetaljer',
		'IMPLEMENT.EDIT': 'Rediger påhængsredskab',
		'IMPLEMENT.EDIT.SUCCESS': 'Påhængsredskab succesfuldt redigeret',
		'IMPLEMENT.FIXED': 'Fast implementering',
		'IMPLEMENT.NO': 'Intet redskab',
		'IMPLEMENT.PROCESS.0': 'Tomkørsel',
		'IMPLEMENT.PROCESS.1': 'Presse rundballer',
		'IMPLEMENT.PROCESS.10': 'Valse',
		'IMPLEMENT.PROCESS.11': 'Så',
		'IMPLEMENT.PROCESS.12': 'Plante',
		'IMPLEMENT.PROCESS.13': 'Organisk gødning',
		'IMPLEMENT.PROCESS.14': 'Sprøjte',
		'IMPLEMENT.PROCESS.15': 'Vande',
		'IMPLEMENT.PROCESS.16': 'Meje',
		'IMPLEMENT.PROCESS.17': 'Drejning af græs',
		'IMPLEMENT.PROCESS.18': 'Transportere',
		'IMPLEMENT.PROCESS.19': 'Feje',
		'IMPLEMENT.PROCESS.2': 'Presse storballer',
		'IMPLEMENT.PROCESS.20': 'Rømme sne',
		'IMPLEMENT.PROCESS.21': 'Strø salt',
		'IMPLEMENT.PROCESS.22': 'Hakke',
		'IMPLEMENT.PROCESS.23': 'Mineralsk gødning',
		'IMPLEMENT.PROCESS.24': 'Pumpe gylle',
		'IMPLEMENT.PROCESS.25': 'Røre gylle',
		'IMPLEMENT.PROCESS.26': 'Lægge kartofler',
		'IMPLEMENT.PROCESS.27': 'Rydde',
		'IMPLEMENT.PROCESS.28': 'Separere',
		'IMPLEMENT.PROCESS.29': 'Voldfræse',
		'IMPLEMENT.PROCESS.3': 'Pressevikle',
		'IMPLEMENT.PROCESS.30': 'Fjerne top',
		'IMPLEMENT.PROCESS.31': 'Rive',
		'IMPLEMENT.PROCESS.32': 'Strigle',
		'IMPLEMENT.PROCESS.33': 'Slæbe',
		'IMPLEMENT.PROCESS.34': 'Dække jorden',
		'IMPLEMENT.PROCESS.35': 'Feje',
		'IMPLEMENT.PROCESS.36': 'Fræse sne',
		'IMPLEMENT.PROCESS.37': 'Flytte gyllecontainer',
		'IMPLEMENT.PROCESS.38': 'Forme bed',
		'IMPLEMENT.PROCESS.39': 'Fodre',
		'IMPLEMENT.PROCESS.4': 'Vikle baller',
		'IMPLEMENT.PROCESS.40': 'Rykke træ',
		'IMPLEMENT.PROCESS.41': 'Save træ',
		'IMPLEMENT.PROCESS.42': 'Spalte træ',
		'IMPLEMENT.PROCESS.43': 'Fræse træstubbe',
		'IMPLEMENT.PROCESS.44': 'Læsse bulkgods',
		'IMPLEMENT.PROCESS.45': 'Læsse paller',
		'IMPLEMENT.PROCESS.46': 'Læsse baller',
		'IMPLEMENT.PROCESS.47': 'Flytte CCM-mølle',
		'IMPLEMENT.PROCESS.48': 'Skubbe',
		'IMPLEMENT.PROCESS.49': 'Vægt foran/bagved',
		'IMPLEMENT.PROCESS.5': 'Pløje',
		'IMPLEMENT.PROCESS.50': 'Tærske',
		'IMPLEMENT.PROCESS.51': 'Snitte',
		'IMPLEMENT.PROCESS.52': 'Presse højtryksballer',
		'IMPLEMENT.PROCESS.53': 'Afblade',
		'IMPLEMENT.PROCESS.54': 'Planere',
		'IMPLEMENT.PROCESS.55': 'Jordbearbejdning',
		'IMPLEMENT.PROCESS.56': 'Pleje af træbevoksning',
		'IMPLEMENT.PROCESS.57': 'Vedligeholdelses-/monteringsarbejde',
		'IMPLEMENT.PROCESS.58': 'Entrain',
		'IMPLEMENT.PROCESS.59': 'Lastning og aflæsning',
		'IMPLEMENT.PROCESS.6': 'Grubbere',
		'IMPLEMENT.PROCESS.60': 'Vask',
		'IMPLEMENT.PROCESS.61': 'Komprimering',
		'IMPLEMENT.PROCESS.7': 'Harver',
		'IMPLEMENT.PROCESS.8': 'Dybdegrubbere',
		'IMPLEMENT.PROCESS.9': 'Fræse',
		'IMPLEMENT.PROCESS.deadhead': 'Intet redskab',
		'IMPLEMENT.REMOVE': 'Fjern redskab',
		'IMPLEMENT.RESOURCE.0': 'udefineret',
		'IMPLEMENT.RESOURCE.1': 'Frisk foder',
		'IMPLEMENT.RESOURCE.10': 'Fast gødning',
		'IMPLEMENT.RESOURCE.11': 'Gylle',
		'IMPLEMENT.RESOURCE.12': 'Kompost',
		'IMPLEMENT.RESOURCE.13': 'Gæringsrest',
		'IMPLEMENT.RESOURCE.14': 'Træflis',
		'IMPLEMENT.RESOURCE.15': 'Majs',
		'IMPLEMENT.RESOURCE.16': 'Solsikker',
		'IMPLEMENT.RESOURCE.17': 'Sorghum',
		'IMPLEMENT.RESOURCE.18': 'Rug',
		'IMPLEMENT.RESOURCE.19': 'Triticale',
		'IMPLEMENT.RESOURCE.2': 'Græsensilage',
		'IMPLEMENT.RESOURCE.20': 'Hvede',
		'IMPLEMENT.RESOURCE.21': 'Hestebønner',
		'IMPLEMENT.RESOURCE.22': 'Ærter',
		'IMPLEMENT.RESOURCE.23': 'Markgræs',
		'IMPLEMENT.RESOURCE.24': 'Kløvergræs',
		'IMPLEMENT.RESOURCE.25': 'Byg',
		'IMPLEMENT.RESOURCE.26': 'Havre',
		'IMPLEMENT.RESOURCE.27': 'Spelt',
		'IMPLEMENT.RESOURCE.28': 'Sæddodder',
		'IMPLEMENT.RESOURCE.29': 'Spindhør',
		'IMPLEMENT.RESOURCE.3': 'GPS',
		'IMPLEMENT.RESOURCE.30': 'Raps',
		'IMPLEMENT.RESOURCE.31': 'Sojabønner',
		'IMPLEMENT.RESOURCE.32': 'Efterafgrøder',
		'IMPLEMENT.RESOURCE.33': 'Gulerødder',
		'IMPLEMENT.RESOURCE.34': 'Kartofler',
		'IMPLEMENT.RESOURCE.35': 'Miscanthus',
		'IMPLEMENT.RESOURCE.36': 'Jordskokker',
		'IMPLEMENT.RESOURCE.37': 'Grøntsager',
		'IMPLEMENT.RESOURCE.38': 'Jordbær',
		'IMPLEMENT.RESOURCE.39': 'AHL',
		'IMPLEMENT.RESOURCE.4': 'Hø',
		'IMPLEMENT.RESOURCE.40': 'Kalk',
		'IMPLEMENT.RESOURCE.41': 'Diammonfosfat',
		'IMPLEMENT.RESOURCE.42': 'Hårmelpiller, PK, K, P, KAS',
		'IMPLEMENT.RESOURCE.43': 'Urinstof',
		'IMPLEMENT.RESOURCE.44': 'Diesel',
		'IMPLEMENT.RESOURCE.45': 'AdBlue',
		'IMPLEMENT.RESOURCE.46': 'Jord',
		'IMPLEMENT.RESOURCE.47': 'Plantebeskyttelsesmiddel',
		'IMPLEMENT.RESOURCE.48': 'Diverse',
		'IMPLEMENT.RESOURCE.49': 'Vand',
		'IMPLEMENT.RESOURCE.5': 'CCM',
		'IMPLEMENT.RESOURCE.50': 'Foderblanding',
		'IMPLEMENT.RESOURCE.6': 'Kornmajs',
		'IMPLEMENT.RESOURCE.7': 'Strå',
		'IMPLEMENT.RESOURCE.8': 'Ensilagemajs',
		'IMPLEMENT.RESOURCE.9': 'Korn',
		'IMPLEMENT.TYPE': 'Apparattype',
		'IMPLEMENT.TYPE.1': 'Presser/Balle-bindeapparater',
		'IMPLEMENT.TYPE.10': 'Transportanhænger',
		'IMPLEMENT.TYPE.10_1': '3-siders tipvogn',
		'IMPLEMENT.TYPE.10_10': 'Blokvogn',
		'IMPLEMENT.TYPE.10_11': 'Container-kroglift-system',
		'IMPLEMENT.TYPE.10_12': 'Kreaturvogn',
		'IMPLEMENT.TYPE.10_13': 'Dolly-aksel',
		'IMPLEMENT.TYPE.10_14': 'Tank-/ensileringsvogne',
		'IMPLEMENT.TYPE.10_2': 'Kar-/liftdumperlad',
		'IMPLEMENT.TYPE.10_3': 'Overlæsningsvogn',
		'IMPLEMENT.TYPE.10_4': 'Platformvogn',
		'IMPLEMENT.TYPE.10_5': 'Læsse-/ensileringsvogn',
		'IMPLEMENT.TYPE.10_6': 'Hakkelsestransportvogn',
		'IMPLEMENT.TYPE.10_7': 'Balletransportvogn',
		'IMPLEMENT.TYPE.10_8': 'Udskubningsvogn',
		'IMPLEMENT.TYPE.10_9': 'Gylletransportvogn',
		'IMPLEMENT.TYPE.11': 'Fodringsteknik',
		'IMPLEMENT.TYPE.11_1': 'Foderblandevogn',
		'IMPLEMENT.TYPE.11_2': 'Foderfordelingsvogn',
		'IMPLEMENT.TYPE.11_3': 'Udtagnings-/fordelingsredskaber',
		'IMPLEMENT.TYPE.12': 'Skovbrugsteknik',
		'IMPLEMENT.TYPE.12_1': 'Udslæbningsanhænger',
		'IMPLEMENT.TYPE.12_2': 'Brændesav',
		'IMPLEMENT.TYPE.12_3': 'Brændeautomat',
		'IMPLEMENT.TYPE.12_4': 'Flishugger',
		'IMPLEMENT.TYPE.12_5': 'Træstammefræser',
		'IMPLEMENT.TYPE.12_6': 'Skovbrugswirespil',
		'IMPLEMENT.TYPE.12_7': 'Skovbrugsdækker',
		'IMPLEMENT.TYPE.12_8': 'Træhugger',
		'IMPLEMENT.TYPE.12_8_1': 'Skivehugger - monteret',
		'IMPLEMENT.TYPE.12_8_2': 'Skivehugger - påhængt',
		'IMPLEMENT.TYPE.12_8_3': 'Tromlehugger - monteret',
		'IMPLEMENT.TYPE.12_8_4': 'Tromlehugger - påhængt',
		'IMPLEMENT.TYPE.12_8_5': 'Tromlehugger - påhængt med egen motor',
		'IMPLEMENT.TYPE.12_9': 'Hydraulisk hækklipper',
		'IMPLEMENT.TYPE.13': 'Kommunal teknik',
		'IMPLEMENT.TYPE.13_1': 'Fejemaskiner',
		'IMPLEMENT.TYPE.13_10': 'Anordning til vedligeholdelse af stier',
		'IMPLEMENT.TYPE.13_11': 'Banquet fræsemaskine',
		'IMPLEMENT.TYPE.13_12': 'Saltbøsse - vedlagt',
		'IMPLEMENT.TYPE.13_13': 'Læsser',
		'IMPLEMENT.TYPE.13_14': 'Vaskemaskine',
		'IMPLEMENT.TYPE.13_15': 'Vandingsanordning',
		'IMPLEMENT.TYPE.13_16': 'Arbejdsplatform',
		'IMPLEMENT.TYPE.13_17': 'Mulcher til overfladen',
		'IMPLEMENT.TYPE.13_18': 'Outrigger foran',
		'IMPLEMENT.TYPE.13_18_1': 'Skærehoved',
		'IMPLEMENT.TYPE.13_18_2': 'Mulchhoved',
		'IMPLEMENT.TYPE.13_18_3': 'Hækkeklipper',
		'IMPLEMENT.TYPE.13_18_4': 'Kurv til udligning',
		'IMPLEMENT.TYPE.13_18_5': 'Rive',
		'IMPLEMENT.TYPE.13_19': 'Outrigger center/struktur',
		'IMPLEMENT.TYPE.13_19_1': 'Skærehoved',
		'IMPLEMENT.TYPE.13_19_2': 'Mulchhoved',
		'IMPLEMENT.TYPE.13_19_3': 'Hækkeklipper',
		'IMPLEMENT.TYPE.13_19_4': 'Kurv til udligning',
		'IMPLEMENT.TYPE.13_19_5': 'Rive',
		'IMPLEMENT.TYPE.13_1_1': 'Frontmontering',
		'IMPLEMENT.TYPE.13_1_2': 'Hækmontering',
		'IMPLEMENT.TYPE.13_1_3': 'Struktur',
		'IMPLEMENT.TYPE.13_2': 'Sneplov',
		'IMPLEMENT.TYPE.13_20': 'Outrigger bagtil',
		'IMPLEMENT.TYPE.13_20_1': 'Skærehoved',
		'IMPLEMENT.TYPE.13_20_2': 'Mulchhoved',
		'IMPLEMENT.TYPE.13_20_3': 'Hækkeklipper',
		'IMPLEMENT.TYPE.13_20_4': 'Kurv til udligning',
		'IMPLEMENT.TYPE.13_20_5': 'Rive',
		'IMPLEMENT.TYPE.13_21': 'Rive',
		'IMPLEMENT.TYPE.13_22': 'Banquet komprimator / pladekomprimator',
		'IMPLEMENT.TYPE.13_3': 'Sneplov - spidsplov',
		'IMPLEMENT.TYPE.13_4': 'Snefræser',
		'IMPLEMENT.TYPE.13_5': 'Saltspreder - monteret',
		'IMPLEMENT.TYPE.13_6': 'Saltspreder - påhængt',
		'IMPLEMENT.TYPE.13_7': 'Kantklipper',
		'IMPLEMENT.TYPE.13_8': 'Slåmaskine til brug ved skråninger',
		'IMPLEMENT.TYPE.13_9': 'Slåmaskine',
		'IMPLEMENT.TYPE.14': 'Læssemaskinearbejde',
		'IMPLEMENT.TYPE.14_1': 'Skovl',
		'IMPLEMENT.TYPE.14_2': 'Skovl til let gods',
		'IMPLEMENT.TYPE.14_3': 'Pallegaffel',
		'IMPLEMENT.TYPE.14_4': 'Balletang',
		'IMPLEMENT.TYPE.14_5': 'Ballegaffel',
		'IMPLEMENT.TYPE.14_6': 'Gribeskovl/-tang',
		'IMPLEMENT.TYPE.14_7': 'Arbejdsplatform',
		'IMPLEMENT.TYPE.14_8': 'Gødningsgaffel',
		'IMPLEMENT.TYPE.15': 'Høstforsatser',
		'IMPLEMENT.TYPE.15_1': 'Skæremaskine',
		'IMPLEMENT.TYPE.15_1_1': 'Skæremaskine - standard',
		'IMPLEMENT.TYPE.15_1_2': 'Skæremaskine - klapbar',
		'IMPLEMENT.TYPE.15_2': 'Majsplukker',
		'IMPLEMENT.TYPE.15_2_1': 'Majsplukker - standard',
		'IMPLEMENT.TYPE.15_3': 'Majsgebis',
		'IMPLEMENT.TYPE.15_4': 'GPS-forsats',
		'IMPLEMENT.TYPE.15_5': 'Pick-up',
		'IMPLEMENT.TYPE.15_6': 'Rydning af vedhæftede filer',
		'IMPLEMENT.TYPE.15_7': 'Indsugningssystem',
		'IMPLEMENT.TYPE.15_8': 'Optagning af svade',
		'IMPLEMENT.TYPE.16': 'Diverse',
		'IMPLEMENT.TYPE.16_1': 'CCM-kornmøller',
		'IMPLEMENT.TYPE.16_2': 'Frontvægt',
		'IMPLEMENT.TYPE.16_3': 'Hækvægt',
		'IMPLEMENT.TYPE.16_4': 'Skubbeskærm',
		'IMPLEMENT.TYPE.17': 'Frugt-/vinavl',
		'IMPLEMENT.TYPE.17_1': 'Rulleplov',
		'IMPLEMENT.TYPE.17_2': 'Plantemaskine',
		'IMPLEMENT.TYPE.17_3': 'Afbladningsmaskine',
		'IMPLEMENT.TYPE.17_4': 'Rodstokfræser',
		'IMPLEMENT.TYPE.18': 'Dyrkning af grøntsager',
		'IMPLEMENT.TYPE.18_1': 'Gulerodshøstmaskine',
		'IMPLEMENT.TYPE.18_2': 'Løghøstmaskine',
		'IMPLEMENT.TYPE.18_4': 'Løghøstmaskine',
		'IMPLEMENT.TYPE.18_5': 'Høstmaskine til porrer',
		'IMPLEMENT.TYPE.19': 'Teknologi til sukkerroer',
		'IMPLEMENT.TYPE.19_1': 'Sukkerroehøstmaskine - bunkerhøstmaskine',
		'IMPLEMENT.TYPE.19_1_1': 'Bunkerhøster',
		'IMPLEMENT.TYPE.19_1_2': 'Overlader eller',
		'IMPLEMENT.TYPE.1_1': 'Rundballepresse',
		'IMPLEMENT.TYPE.1_2': 'Storballepresse',
		'IMPLEMENT.TYPE.1_3': 'Presse-/samlekombination',
		'IMPLEMENT.TYPE.1_4': 'Ballesamleredskab',
		'IMPLEMENT.TYPE.1_5': 'Højtrykspresse',
		'IMPLEMENT.TYPE.2': 'Jordbearbejdning',
		'IMPLEMENT.TYPE.2_1': 'Plov',
		'IMPLEMENT.TYPE.2_10': 'Fræser',
		'IMPLEMENT.TYPE.2_10_1': 'Fræser - monteret',
		'IMPLEMENT.TYPE.2_10_2': 'Fræser - vedhæftet',
		'IMPLEMENT.TYPE.2_11': 'Frontmonteret jordpakker',
		'IMPLEMENT.TYPE.2_12': 'Valse',
		'IMPLEMENT.TYPE.2_12_1': 'Rulle - monteret',
		'IMPLEMENT.TYPE.2_12_2': 'Rulle - fastgjort',
		'IMPLEMENT.TYPE.2_13': 'Spaderulleharve',
		'IMPLEMENT.TYPE.2_13_1': 'Rokkelharver - monteret',
		'IMPLEMENT.TYPE.2_13_2': 'Rotary harver - vedhæftet',
		'IMPLEMENT.TYPE.2_14': 'Rotorgrubber',
		'IMPLEMENT.TYPE.2_14_1': 'Rotary kultivator - monteret',
		'IMPLEMENT.TYPE.2_14_2': 'Rotary cultivator - vedhæftet',
		'IMPLEMENT.TYPE.2_15': 'Frøbedskombination',
		'IMPLEMENT.TYPE.2_15_1': 'Kombination af såbed - monteret',
		'IMPLEMENT.TYPE.2_15_2': 'Kombination af frøbed - vedlagt',
		'IMPLEMENT.TYPE.2_16': 'Pakker',
		'IMPLEMENT.TYPE.2_17': 'Planeringsmaskine',
		'IMPLEMENT.TYPE.2_17_1': 'Skrabere - monteret',
		'IMPLEMENT.TYPE.2_17_2': 'Skrabere - vedhæftet',
		'IMPLEMENT.TYPE.2_18': 'Storrive',
		'IMPLEMENT.TYPE.2_18_1': 'Stråharve - monteret',
		'IMPLEMENT.TYPE.2_18_2': 'Halmharve - vedhæftet',
		'IMPLEMENT.TYPE.2_19': 'Flishugger/flisrive',
		'IMPLEMENT.TYPE.2_19_1': 'Monterede kultivatorer - monteret',
		'IMPLEMENT.TYPE.2_19_2': 'Yderligere kultivatorer - vedlagt',
		'IMPLEMENT.TYPE.2_1_1': 'Plov - påhængt',
		'IMPLEMENT.TYPE.2_1_2': 'Plov - monteret',
		'IMPLEMENT.TYPE.2_1_3': 'Plov - monteret (on land)',
		'IMPLEMENT.TYPE.2_2': 'Grubber',
		'IMPLEMENT.TYPE.2_20': 'Anden jordbearbejdning',
		'IMPLEMENT.TYPE.2_2_1': 'Grubber - påhængt',
		'IMPLEMENT.TYPE.2_2_2': 'Grubber - monteret',
		'IMPLEMENT.TYPE.2_3': 'Tallerkenharve',
		'IMPLEMENT.TYPE.2_3_1': 'Tallerkenharve - påhængt',
		'IMPLEMENT.TYPE.2_3_2': 'Tallerkenharve - monteret',
		'IMPLEMENT.TYPE.2_4': 'Kompakt tallerkenharve',
		'IMPLEMENT.TYPE.2_4_1': 'Compact disc harve - monteret',
		'IMPLEMENT.TYPE.2_4_2': 'Compact disc harve - vedhæftet',
		'IMPLEMENT.TYPE.2_5': 'Undergrundsløsner',
		'IMPLEMENT.TYPE.2_5_1': 'Dybe løsnere - monteret',
		'IMPLEMENT.TYPE.2_5_2': 'Dybdemøller - fastgjort',
		'IMPLEMENT.TYPE.2_6': 'Spadeplov',
		'IMPLEMENT.TYPE.2_6_1': 'Spademaskine - monteret',
		'IMPLEMENT.TYPE.2_6_2': 'Spademaskine - vedlagt',
		'IMPLEMENT.TYPE.2_7': 'Rotorharve',
		'IMPLEMENT.TYPE.2_7_1': 'Rotary harve - monteret',
		'IMPLEMENT.TYPE.2_7_2': 'Rotary harve - vedhæftet',
		'IMPLEMENT.TYPE.2_8': 'Tandrotor',
		'IMPLEMENT.TYPE.2_8_1': 'Roterende hakke - monteret',
		'IMPLEMENT.TYPE.2_8_2': 'Roterende hakke - vedhæftet',
		'IMPLEMENT.TYPE.2_9': 'Rysteharve',
		'IMPLEMENT.TYPE.2_9_1': 'Pendulharve - monteret',
		'IMPLEMENT.TYPE.2_9_2': 'Pendulharve - vedhæftet',
		'IMPLEMENT.TYPE.3': 'Så-/plantetekniknik',
		'IMPLEMENT.TYPE.3_1': 'Såmaskine - mekanisk',
		'IMPLEMENT.TYPE.3_1_1': 'Såmaskine - monteret',
		'IMPLEMENT.TYPE.3_1_2': 'Såmaskine - påhængt',
		'IMPLEMENT.TYPE.3_1_3': 'Såkombination - monteret',
		'IMPLEMENT.TYPE.3_1_4': 'Såkombination - påhængt',
		'IMPLEMENT.TYPE.3_2': 'Såmaskine - pneumatisk',
		'IMPLEMENT.TYPE.3_2_1': 'Såmaskine - monteret',
		'IMPLEMENT.TYPE.3_2_2': 'Såmaskine - påhængt',
		'IMPLEMENT.TYPE.3_2_3': 'Såkombination - monteret',
		'IMPLEMENT.TYPE.3_2_4': 'Såkombination - påhængt',
		'IMPLEMENT.TYPE.3_3': 'Enkeltkornsåmaskine - mekanisk',
		'IMPLEMENT.TYPE.3_3_1': 'Såmaskine - monteret',
		'IMPLEMENT.TYPE.3_3_2': 'Såmaskine - påhængt',
		'IMPLEMENT.TYPE.3_3_3': 'Såkombination - monteret',
		'IMPLEMENT.TYPE.3_3_4': 'Såkombination - påhængt',
		'IMPLEMENT.TYPE.3_4': 'Enkeltkornsåmaskine - pneumatisk',
		'IMPLEMENT.TYPE.3_4_1': 'Såmaskine - monteret',
		'IMPLEMENT.TYPE.3_4_2': 'Såmaskine - påhængt',
		'IMPLEMENT.TYPE.3_4_3': 'Såkombination - monteret',
		'IMPLEMENT.TYPE.3_4_4': 'Såkombination - påhængt',
		'IMPLEMENT.TYPE.3_5': 'Direkte såmaskine',
		'IMPLEMENT.TYPE.3_5_1': 'Direkte såmaskine - monteret',
		'IMPLEMENT.TYPE.3_5_2': 'Direkte såmaskine - vedlagt',
		'IMPLEMENT.TYPE.3_6': 'Enkeltkorn direkte såmaskine',
		'IMPLEMENT.TYPE.3_6_1': 'Enkeltkornssåmaskine til direkte såning - monteret',
		'IMPLEMENT.TYPE.3_6_2': 'Enkeltkornssåmaskine til direkte såning - vedlagt',
		'IMPLEMENT.TYPE.3_7': 'Plantemaskiner',
		'IMPLEMENT.TYPE.3_7_1': 'Plantekasse - monteret',
		'IMPLEMENT.TYPE.3_7_2': 'Plantekasse - vedhæftet',
		'IMPLEMENT.TYPE.3_8': 'Eftersåningsmaskine til græsmarker',
		'IMPLEMENT.TYPE.3_8_1': 'Såmaskine til græsarealer - monteret',
		'IMPLEMENT.TYPE.3_8_2': 'Græsmarkssåmaskine - vedlagt',
		'IMPLEMENT.TYPE.3_9': 'Fronttank',
		'IMPLEMENT.TYPE.4': 'Gødeteknik',
		'IMPLEMENT.TYPE.4_1': 'Gødningsspreder - monteret',
		'IMPLEMENT.TYPE.4_2': 'Gødningsspreder - påhængt',
		'IMPLEMENT.TYPE.5': 'Plantebeskyttelsesteknik',
		'IMPLEMENT.TYPE.5_1': 'Plantebeskyttelsessprøjte - monteret',
		'IMPLEMENT.TYPE.5_2': 'Plantebeskyttelsessprøjte - påhængt',
		'IMPLEMENT.TYPE.5_3': 'Flisrive/flishugger',
		'IMPLEMENT.TYPE.5_3_1': 'Hacke - monteret',
		'IMPLEMENT.TYPE.5_3_2': 'Hakke - vedhæftet',
		'IMPLEMENT.TYPE.5_4': 'Ugræsser',
		'IMPLEMENT.TYPE.5_4_1': 'Ugræsslåmaskine - monteret',
		'IMPLEMENT.TYPE.5_4_2': 'Ugræsslåmaskine - vedhæftet',
		'IMPLEMENT.TYPE.6': 'Gylle-/gødeteknik',
		'IMPLEMENT.TYPE.6_1': 'Gøde-/Kompostspreder',
		'IMPLEMENT.TYPE.6_2': 'Gyllevogn',
		'IMPLEMENT.TYPE.6_2_1': 'Deflektor',
		'IMPLEMENT.TYPE.6_2_2': 'Slæbeslangefordeler',
		'IMPLEMENT.TYPE.6_2_3': 'Slæbeskofordeler',
		'IMPLEMENT.TYPE.6_2_4': 'Injektionsgrubber',
		'IMPLEMENT.TYPE.6_2_5': 'Injektionstallerkenharve',
		'IMPLEMENT.TYPE.6_2_6': 'Slidseapparat',
		'IMPLEMENT.TYPE.6_2_7': 'Striptill injektor',
		'IMPLEMENT.TYPE.6_2_8': 'Svingfordeler',
		'IMPLEMENT.TYPE.6_3': 'Gyllepumper',
		'IMPLEMENT.TYPE.6_4': 'Gyllemikser',
		'IMPLEMENT.TYPE.6_5': 'Gyllecontainer',
		'IMPLEMENT.TYPE.6_6': 'Slangesystem',
		'IMPLEMENT.TYPE.6_6_1': 'Slæbeslangefordeler',
		'IMPLEMENT.TYPE.6_6_2': 'Slæbeskofordeler',
		'IMPLEMENT.TYPE.6_6_3': 'Slidseapparat',
		'IMPLEMENT.TYPE.6_6_4': 'Injektionsgrubber',
		'IMPLEMENT.TYPE.6_6_5': 'Injektionstallerkenharve',
		'IMPLEMENT.TYPE.6_6_6': 'Striptill injektor',
		'IMPLEMENT.TYPE.6_6_7': 'Svingfordeler',
		'IMPLEMENT.TYPE.7': 'Vandingsteknik',
		'IMPLEMENT.TYPE.7_1': 'Vandingsmaskine med dysevogn',
		'IMPLEMENT.TYPE.7_2': 'Vandingsmaskine med individuelt vandingsapparat',
		'IMPLEMENT.TYPE.8': 'Kartoffelteknik',
		'IMPLEMENT.TYPE.8_1': 'Kartoffelteknik',
		'IMPLEMENT.TYPE.8_1_1': 'Plantemaskine uden rotorharve/fuldmarksfræser',
		'IMPLEMENT.TYPE.8_1_2': 'Plantemaskine med rotorharve/fuldmarksfræser',
		'IMPLEMENT.TYPE.8_1_3': 'Plantemaskine uden rotorharve/fuldmarksfræser påhængt',
		'IMPLEMENT.TYPE.8_1_4': 'Plantemaskine med rotorharve/fuldmarksfræser monteret',
		'IMPLEMENT.TYPE.8_2': 'Kartoffeloptager - rækkelægger',
		'IMPLEMENT.TYPE.8_3': 'Kartoffeloptager - bunkerroder',
		'IMPLEMENT.TYPE.8_4': 'Kartoffeloptager - læsseoptager',
		'IMPLEMENT.TYPE.8_5': 'Bedformer',
		'IMPLEMENT.TYPE.8_6': 'Separator',
		'IMPLEMENT.TYPE.8_7': 'Voldfræser',
		'IMPLEMENT.TYPE.8_8': 'Topfjerner',
		'IMPLEMENT.TYPE.9': 'Græsmarkmaskiner',
		'IMPLEMENT.TYPE.9_1': 'Tromleslåmaskine',
		'IMPLEMENT.TYPE.9_1_1': 'Tromleslåmaskine med behandler',
		'IMPLEMENT.TYPE.9_1_2': 'Tromleslåmaskine uden behandler',
		'IMPLEMENT.TYPE.9_1_3': 'Tromleslåmaskine med behandler, monteret',
		'IMPLEMENT.TYPE.9_1_4': 'Tromleslåmaskine uden behandler, påhængt',
		'IMPLEMENT.TYPE.9_2': 'Bjælkeslåmaskine',
		'IMPLEMENT.TYPE.9_2_1': 'Skiveslåmaskine med behandler',
		'IMPLEMENT.TYPE.9_2_2': 'Skiveslåmaskine uden behandler',
		'IMPLEMENT.TYPE.9_2_3': 'Skiveslåmaskine med behandler, monteret',
		'IMPLEMENT.TYPE.9_2_4': 'Skiveslåmaskine uden behandler, monteret',
		'IMPLEMENT.TYPE.9_3': 'Rotorhøvender',
		'IMPLEMENT.TYPE.9_3_1': 'Rotorhøvender, monteret',
		'IMPLEMENT.TYPE.9_3_2': 'Rotorhøvender, påhængt',
		'IMPLEMENT.TYPE.9_4': 'Rive',
		'IMPLEMENT.TYPE.9_4_1': 'Rive med en rotor',
		'IMPLEMENT.TYPE.9_4_2': 'Rive med to rotorer med henlægning i siden',
		'IMPLEMENT.TYPE.9_4_3': 'Rive med to rotorer med henlægning i midten',
		'IMPLEMENT.TYPE.9_4_4': 'Rive med fire rotorer',
		'IMPLEMENT.TYPE.9_4_5': 'Båndrive',
		'IMPLEMENT.TYPE.9_4_6': 'Rive med stjernerive',
		'IMPLEMENT.TYPE.9_5': 'Agerrive',
		'IMPLEMENT.TYPE.9_6': 'Agerslæber',
		'IMPLEMENT.TYPE.9_7': 'Agervalse',
		'IMPLEMENT.TYPE.9_8': 'Tildækker',
		'IMPLEMENTS': 'Påhængsredskaber',
		'IMPLEMENTS.ALL': 'Alle redskaber',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Nogle af redskaberne kunne ikke deaktiveres.',
		'IMPLEMENTS.DEACTIVATE.QUESTION': 'Vil du virkelig deaktivere de valgte redskaber?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Implementerer deaktiveret med succes',
		'IMPLEMENTS.DELETE.FAILURE': 'Nogle af redskaberne kunne ikke slettes.',
		'IMPLEMENTS.DELETE.QUESTION': 'Ønsker du virkelig at slette de valgte redskaber?',
		'IMPLEMENTS.DELETE.SUCCESS': 'Redskaber er blevet slettet',
		'IMPLEMENTS.MANAGEMENT': 'Påhængsredskabs-/anhænger-administration',
		'IMPLEMENTS.NO': 'Ingen redskaber',
		'IMPLEMENTS.NOT_SELECTED': 'Ingen redskaber valgt',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Nogle af redskaberne kunne ikke genaktiveres.',
		'IMPLEMENTS.REACTIVATE.QUESTION': 'Vil du virkelig genaktivere de valgte redskaber?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Redskaber genaktiveret med succes',
		'IMPLEMENTS.SELECTED': 'Udvalgte redskaber',
		'IMPLEMENT_SCAN_DISABLED': 'Redskab-Beacon scan inaktiv',
		'IMPORT': 'Importer',
		'INACTIVE': 'Inaktiv',
		'INDIVIDUAL_LABELING': 'Brugerdefineret mærkning',
		'INFO': 'Info',
		'INTERPOLATION.MAP': 'Interpolationskort',
		'INTERPOLATION.MAP.SETTINGS': 'Indstillinger for interpolationskort',
		'IO_BOX_ACTIVATED': 'IOBox aktiv',
		'ISOBUS.DDI.1': 'Indstillingsværdi udbringningsmængde',
		'ISOBUS.DDI.10': 'Maksimal udbringningsmængde',
		'ISOBUS.DDI.100': 'Forurening høstmateriale',
		'ISOBUS.DDI.101': 'Indstillingsværdi ballebredde',
		'ISOBUS.DDI.102': 'Faktisk værdi ballebredde',
		'ISOBUS.DDI.103': 'Forudindstillet ballebredde',
		'ISOBUS.DDI.104': 'Minimal ballebredde',
		'ISOBUS.DDI.105': 'Maksimal ballebredde',
		'ISOBUS.DDI.106': 'Indstillingsværdi ballehøjde',
		'ISOBUS.DDI.107': 'Faktisk værdi ballehøjde',
		'ISOBUS.DDI.108': 'Forudindstillet ballehøjde',
		'ISOBUS.DDI.109': 'Minimal ballehøjde',
		'ISOBUS.DDI.11': 'Indstillingsværdi udbringningsmængde',
		'ISOBUS.DDI.110': 'Maksimal ballehøjde',
		'ISOBUS.DDI.111': 'Indstillingsværdi ballelængde',
		'ISOBUS.DDI.112': 'Faktisk ballelængde',
		'ISOBUS.DDI.113': 'Forudindstillet ballelængde',
		'ISOBUS.DDI.114': 'Minimal ballelængde',
		'ISOBUS.DDI.115': 'Maksimal ballelængde',
		'ISOBUS.DDI.116': 'Bearbejdet areal i alt',
		'ISOBUS.DDI.117': 'Strækning i arbejdsstilling',
		'ISOBUS.DDI.118': 'Strækning ikke i arbejdsstilling',
		'ISOBUS.DDI.119': 'Tid i arbejdsstilling',
		'ISOBUS.DDI.12': 'Faktisk værdi udbringningsmængde',
		'ISOBUS.DDI.120': 'Tid ikke i arbejdsstilling',
		'ISOBUS.DDI.121': 'Tæthed høstmateriale',
		'ISOBUS.DDI.122': 'Tæthed høstmateriale',
		'ISOBUS.DDI.123': 'Tæthed høstmateriale',
		'ISOBUS.DDI.124': 'Faktor hydraulikventil udgang',
		'ISOBUS.DDI.125': 'Faktor hydraulikventil indgang',
		'ISOBUS.DDI.126': 'Åbn stigning hydraulikventil udgang',
		'ISOBUS.DDI.127': 'Luk stigning hydraulikventil udgang',
		'ISOBUS.DDI.128': 'Åbn stigning hydraulikventil indgang',
		'ISOBUS.DDI.129': 'Luk stigning hydraulikventil indgang',
		'ISOBUS.DDI.13': 'Forudindstillet udbringningsmængde',
		'ISOBUS.DDI.130': 'Tærskel flydestilling hydraulikventil',
		'ISOBUS.DDI.131': 'Forøg hjælpeventil progressivitet',
		'ISOBUS.DDI.132': 'Reducer hjælpeventil progressivitet',
		'ISOBUS.DDI.133': 'Hydraulikventil vendemodus',
		'ISOBUS.DDI.134': 'Flytning maskine X-retning',
		'ISOBUS.DDI.135': 'Flytning maskine Y-retning',
		'ISOBUS.DDI.136': 'Flytning maskine Z-retning',
		'ISOBUS.DDI.137': 'Kapacitet maskine',
		'ISOBUS.DDI.138': 'Kapacitet maskine',
		'ISOBUS.DDI.139': 'Kapacitet maskine',
		'ISOBUS.DDI.14': 'Minimal udbringningsmængde',
		'ISOBUS.DDI.140': 'Udbringningsmængde',
		'ISOBUS.DDI.141': 'Arbejdsstilling',
		'ISOBUS.DDI.142': 'Tidsforsinkelse indstillingsværdi',
		'ISOBUS.DDI.143': 'Tidsforsinkelse faktisk værdi',
		'ISOBUS.DDI.144': 'Drejningsvinkel',
		'ISOBUS.DDI.145': 'Rullevinkel',
		'ISOBUS.DDI.146': 'Indfaldsvinkel',
		'ISOBUS.DDI.147': 'Log-tæller',
		'ISOBUS.DDI.148': 'Brændstofforbrug i alt',
		'ISOBUS.DDI.149': 'Brændstofforbrug',
		'ISOBUS.DDI.15': 'Maksimal udbringningsmængde',
		'ISOBUS.DDI.150': 'Brændstofforbrug',
		'ISOBUS.DDI.151': 'Arealydelse',
		'ISOBUS.DDI.153': 'NDVI indeks',
		'ISOBUS.DDI.154': 'Maskine længde',
		'ISOBUS.DDI.155': 'Maskine bredde',
		'ISOBUS.DDI.156': 'Maskine højde',
		'ISOBUS.DDI.157': 'Påhæng',
		'ISOBUS.DDI.158': 'Status delarealspecifik udbringning',
		'ISOBUS.DDI.159': 'Antal af underenheder pr. afsnit',
		'ISOBUS.DDI.16': 'Indstillingsværdi plantevidde',
		'ISOBUS.DDI.160': 'Status automatisk delbreddekobling',
		'ISOBUS.DDI.161': 'Arbejdsstilling enheder 1-16',
		'ISOBUS.DDI.162': 'Arbejdsstilling enheder 17-32',
		'ISOBUS.DDI.163': 'Arbejdsstilling enheder 33-48',
		'ISOBUS.DDI.164': 'Arbejdsstilling enheder 49-64',
		'ISOBUS.DDI.165': 'Arbejdsstilling enheder 65-80',
		'ISOBUS.DDI.166': 'Arbejdsstilling enheder 81-96',
		'ISOBUS.DDI.167': 'Arbejdsstilling enheder 97-112',
		'ISOBUS.DDI.168': 'Arbejdsstilling enheder 113-128',
		'ISOBUS.DDI.169': 'Arbejdsstilling enheder 129-144',
		'ISOBUS.DDI.17': 'Faktisk værdi plantevidde',
		'ISOBUS.DDI.170': 'Arbejdsstilling enheder 145-160',
		'ISOBUS.DDI.171': 'Arbejdsstilling enheder 161-176',
		'ISOBUS.DDI.172': 'Arbejdsstilling enheder 177-192',
		'ISOBUS.DDI.173': 'Arbejdsstilling enheder 193-208',
		'ISOBUS.DDI.174': 'Arbejdsstilling enheder 209-224',
		'ISOBUS.DDI.175': 'Arbejdsstilling enheder 225-240',
		'ISOBUS.DDI.176': 'Arbejdsstilling enheder 241-256',
		'ISOBUS.DDI.177': 'Faktisk værdi skærelængde',
		'ISOBUS.DDI.178': 'Elementtype-instans (ETI)',
		'ISOBUS.DDI.179': 'Flytte',
		'ISOBUS.DDI.18': 'Forudindstillet plantevidde',
		'ISOBUS.DDI.180': 'Maskine-referencepunkt (DRP)afstand til jorden',
		'ISOBUS.DDI.181': 'Udbytte tørstof',
		'ISOBUS.DDI.182': 'Udbytte tørstof',
		'ISOBUS.DDI.183': 'Udbytte tørstof i alt',
		'ISOBUS.DDI.184': 'Fugtighed',
		'ISOBUS.DDI.185': 'Udbytte bomuldsfrø',
		'ISOBUS.DDI.186': 'Udbytte bomuldsfibre',
		'ISOBUS.DDI.187': 'Udbytte bomuldsfrø',
		'ISOBUS.DDI.188': 'Udbytte bomuldsfibre',
		'ISOBUS.DDI.189': 'Udbytte bomuldsfrø i alt',
		'ISOBUS.DDI.19': 'Minimal plantevidde',
		'ISOBUS.DDI.190': 'Udbytte bomuldsfibre i alt',
		'ISOBUS.DDI.191': 'Fiberandel',
		'ISOBUS.DDI.192': 'Omgivelsestemperatur',
		'ISOBUS.DDI.193': 'Indstillingsværdi udbringningstryk',
		'ISOBUS.DDI.194': 'Faktisk værdi udbringningstryk',
		'ISOBUS.DDI.195': 'Minimalt udbringningstryk',
		'ISOBUS.DDI.196': 'Maksimalt udbringningstryk',
		'ISOBUS.DDI.197': 'Indstillingsværdi transporttryk',
		'ISOBUS.DDI.198': 'Faktisk værdi transporttryk',
		'ISOBUS.DDI.199': 'Minmalt transporttryk',
		'ISOBUS.DDI.2': 'Faktisk værdi udbringningsmængde',
		'ISOBUS.DDI.20': 'Maksimal plantevidde',
		'ISOBUS.DDI.200': 'Maksimalt transporttryk',
		'ISOBUS.DDI.201': 'Indstillingsværdi tryk skyllesystem',
		'ISOBUS.DDI.202': 'Faktisk værdi tryk skyllesystem',
		'ISOBUS.DDI.203': 'Minimalt tryk skyllesystem',
		'ISOBUS.DDI.204': 'Maksimalt tryk skyllesystem',
		'ISOBUS.DDI.205': 'Section Control tilkoblingstid',
		'ISOBUS.DDI.206': 'Section Control frakoblingstid',
		'ISOBUS.DDI.207': 'Vindhastighed',
		'ISOBUS.DDI.208': 'Vindretning',
		'ISOBUS.DDI.209': 'Relativ luftfugtighed',
		'ISOBUS.DDI.21': 'Indstillingsværdi applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.210': 'Dækningsareal himmel',
		'ISOBUS.DDI.211': 'Antal kompressionsslag seneste balle',
		'ISOBUS.DDI.212': 'Seneste balles gennemsnitlige fugt',
		'ISOBUS.DDI.213': 'Antal raffeslag pr. kompressionsslag seneste balle',
		'ISOBUS.DDI.214': 'Baller i alt',
		'ISOBUS.DDI.215': 'Driftstimer i alt',
		'ISOBUS.DDI.216': 'Faktisk værdi pressetryk',
		'ISOBUS.DDI.217': 'Pressetryk seneste balle',
		'ISOBUS.DDI.218': 'Indstillingsværdi pressekraft',
		'ISOBUS.DDI.219': 'Faktisk pressekraft',
		'ISOBUS.DDI.22': 'Faktisk værdi applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.220': 'Pressekraft seneste balle',
		'ISOBUS.DDI.221': 'Mængde konserveringsmiddel seneste balle',
		'ISOBUS.DDI.222': 'Dag-nummer seneste balle',
		'ISOBUS.DDI.223': 'Masse seneste balle',
		'ISOBUS.DDI.224': 'Delta T',
		'ISOBUS.DDI.225': 'Indstillingsværdi arbejdslængde',
		'ISOBUS.DDI.226': 'Faktisk værdi arbejdslængde',
		'ISOBUS.DDI.227': 'Minimal arbejdslængde',
		'ISOBUS.DDI.228': 'Maksimal arbejdslængde',
		'ISOBUS.DDI.229': 'Faktisk værdi vægt netto',
		'ISOBUS.DDI.23': 'Forudindstillet applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.230': 'Status vægt netto',
		'ISOBUS.DDI.231': 'Indstillingsværdi vægt netto',
		'ISOBUS.DDI.232': 'Faktisk værdi vægt brutto',
		'ISOBUS.DDI.233': 'Status vægt brutto',
		'ISOBUS.DDI.234': 'Minimal vægt brutto',
		'ISOBUS.DDI.235': 'Maksimal vægt brutto',
		'ISOBUS.DDI.236': 'Driftstimer tærsketromle',
		'ISOBUS.DDI.237': 'Arbejdsstilling høstforsats',
		'ISOBUS.DDI.238': 'Arbejdsstilling høstforsats (omdrejningstal)',
		'ISOBUS.DDI.239': 'Status udbyttemåling',
		'ISOBUS.DDI.24': 'Minimal applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.240': 'Status læsse-/aflæssesystem',
		'ISOBUS.DDI.241': 'Temperatur høstmateriale',
		'ISOBUS.DDI.242': 'Indstillingsværdi åbning undersi',
		'ISOBUS.DDI.243': 'Faktisk værdi åbning undersi',
		'ISOBUS.DDI.244': 'Minimal åbning undersi',
		'ISOBUS.DDI.245': 'Maksimal åbning undersi',
		'ISOBUS.DDI.246': 'Indstillingsværdi åbning oversi',
		'ISOBUS.DDI.247': 'Faktisk værdi åbning oversi',
		'ISOBUS.DDI.248': 'Minimal åbning oversi',
		'ISOBUS.DDI.249': 'Maksimal åbning oversi',
		'ISOBUS.DDI.25': 'Maksimal applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.250': 'Indstillingsværdi tærskekurvåbning',
		'ISOBUS.DDI.251': 'Faktisk værdi tærskekurvåbning',
		'ISOBUS.DDI.252': 'Minimal tærskekurvåbning',
		'ISOBUS.DDI.253': 'Maksimal tærskekurvåbning',
		'ISOBUS.DDI.254': 'Indstillingsværdi omdrejningstal blæser',
		'ISOBUS.DDI.255': 'Faktisk værdi omdrejningstal blæser',
		'ISOBUS.DDI.256': 'Minimalt omdrejningstal blæser',
		'ISOBUS.DDI.257': 'Maksimalt omdrejningstal blæser',
		'ISOBUS.DDI.258': 'Temperatur hydraulikolie',
		'ISOBUS.DDI.259': 'Sluk forsinkelse udbyttemåling',
		'ISOBUS.DDI.26': 'Indstillingsværdi applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.260': 'Forsinkelse udbyttemåling tænd',
		'ISOBUS.DDI.261': 'Gennemsnitlig høstmængde',
		'ISOBUS.DDI.262': 'Gennemsnitlig fugt',
		'ISOBUS.DDI.263': 'Gennemsnitlig høstmængde',
		'ISOBUS.DDI.264': 'Offset i X-retning ophængning relativ ift. DRP',
		'ISOBUS.DDI.265': 'Restareal',
		'ISOBUS.DDI.266': 'Udbringningsmængde i alt',
		'ISOBUS.DDI.267': 'Udbringningsmængde i alt',
		'ISOBUS.DDI.268': 'Høstmængde i alt',
		'ISOBUS.DDI.269': 'Høstmængde i alt',
		'ISOBUS.DDI.27': 'Faktisk værdi applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.270': 'Høstmængde i alt',
		'ISOBUS.DDI.271': 'Bearbejdet areal i alt',
		'ISOBUS.DDI.272': 'Strækning i arbejdsstilling',
		'ISOBUS.DDI.273': 'Strækning ikke i arbejdsstilling',
		'ISOBUS.DDI.274': 'Driftstimer i arbejdsstilling i alt',
		'ISOBUS.DDI.275': 'Driftstimer ikke i arbejdsstilling i alt',
		'ISOBUS.DDI.276': 'Brændstofforbrug i alt',
		'ISOBUS.DDI.277': 'Brændstofforbrug i alt',
		'ISOBUS.DDI.278': 'Brændstofforbrug i alt',
		'ISOBUS.DDI.279': 'Udbytte tørstof i alt',
		'ISOBUS.DDI.28': 'Forudindstillet applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.280': 'Udbytte bomuldsfrø i alt',
		'ISOBUS.DDI.281': 'Udbytte bomuldsfibre i alt',
		'ISOBUS.DDI.282': 'Driftstimer tærsketromle',
		'ISOBUS.DDI.283': 'Høstmateriale skåret',
		'ISOBUS.DDI.284': 'Høstmateriale ikke skåret',
		'ISOBUS.DDI.285': 'Høstmateriale skåret i alt',
		'ISOBUS.DDI.286': 'Høstmateriale ikke skåret i alt',
		'ISOBUS.DDI.287': 'Indstillingsstatus styring udbringningsmængde',
		'ISOBUS.DDI.288': 'Faktisk status styring udbringningsmængde',
		'ISOBUS.DDI.289': 'Indstillingsværdi arbejdsstilling',
		'ISOBUS.DDI.29': 'Minimal applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.290': 'Indstillingsværdi arbejdsstilling enheder 1-16',
		'ISOBUS.DDI.291': 'Indstillingsværdi arbejdsstilling enheder 17-32',
		'ISOBUS.DDI.292': 'Indstillingsværdi arbejdsstilling enheder 33-48',
		'ISOBUS.DDI.293': 'Indstillingsværdi arbejdsstilling enheder 49-64',
		'ISOBUS.DDI.294': 'Indstillingsværdi arbejdsstilling enheder 65-80',
		'ISOBUS.DDI.295': 'Indstillingsværdi arbejdsstilling enheder 81-96',
		'ISOBUS.DDI.296': 'Indstillingsværdi arbejdsstilling enheder 97-112',
		'ISOBUS.DDI.297': 'Indstillingsværdi arbejdsstilling enheder 113-128',
		'ISOBUS.DDI.298': 'Indstillingsværdi arbejdsstilling enheder 129-144',
		'ISOBUS.DDI.299': 'Indstillingsværdi arbejdsstilling enheder 145-160',
		'ISOBUS.DDI.3': 'Forudindstillet udbringningsmængde',
		'ISOBUS.DDI.30': 'Maksimal applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.300': 'Indstillingsværdi arbejdsstilling enheder 161-176',
		'ISOBUS.DDI.301': 'Indstillingsværdi arbejdsstilling enheder 177-192',
		'ISOBUS.DDI.302': 'Indstillingsværdi arbejdsstilling enheder 193-208',
		'ISOBUS.DDI.303': 'Indstillingsværdi arbejdsstilling enheder 209-224',
		'ISOBUS.DDI.304': 'Indstillingsværdi arbejdsstilling enheder 225-240',
		'ISOBUS.DDI.305': 'Indstillingsværdi arbejdsstilling enheder 241-256',
		'ISOBUS.DDI.306': 'Offset drejepunkt enhed i X-retning relativt til DRP',
		'ISOBUS.DDI.307': 'Offset drejepunkt enhed i Y-retning relativt til DRP',
		'ISOBUS.DDI.308': 'Faktisk værdi udbringningsmængde',
		'ISOBUS.DDI.309': 'Minimal udbringningsmængde',
		'ISOBUS.DDI.31': 'Indstillingsværdi applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.310': 'Maksimal udbringningsmængde',
		'ISOBUS.DDI.311': 'Udbyttepotentiale',
		'ISOBUS.DDI.312': 'Minimalt udbyttepotentiale',
		'ISOBUS.DDI.313': 'Maksimalt udbyttepotentiale',
		'ISOBUS.DDI.314': 'Faktisk værdi TS-indhold høstmateriale',
		'ISOBUS.DDI.315': 'Gennemsnitligt TS-indhold høstmateriale',
		'ISOBUS.DDI.316': 'Brændstofforbrug i arbejdsstilling i alt',
		'ISOBUS.DDI.317': 'Brændstofforbrug ikke i arbejdsstilling i alt',
		'ISOBUS.DDI.318': 'Ad-Blue forbrug i arbejdsstilling i alt',
		'ISOBUS.DDI.319': 'Ad-Blue forbrug ikke i arbejdsstilling i alt',
		'ISOBUS.DDI.32': 'Faktisk værdi applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.320': 'Læsse seneste vægt',
		'ISOBUS.DDI.321': 'Seneste vægt ikke læsset',
		'ISOBUS.DDI.322': 'Identifikationsnummer læsning',
		'ISOBUS.DDI.323': 'Identifikationsnummer losning',
		'ISOBUS.DDI.324': 'Driftstimer halmsnittertromle',
		'ISOBUS.DDI.325': 'Udbringningsmængde i alt',
		'ISOBUS.DDI.326': 'Indstillingsværdi omdrejningstal høstforsats',
		'ISOBUS.DDI.327': 'Faktisk drejetal høstforsats',
		'ISOBUS.DDI.328': 'Minimalt omdrejningstal høstforsats',
		'ISOBUS.DDI.329': 'Maksimalt omdrejningstal høstforsats',
		'ISOBUS.DDI.33': 'Forudindstillet applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.330': 'Indstillingsværdi tromlehastighed',
		'ISOBUS.DDI.331': 'Faktisk værdi tromlehastighed',
		'ISOBUS.DDI.332': 'Minimal tromlehastighed',
		'ISOBUS.DDI.333': 'Maksimal tromlehastighed',
		'ISOBUS.DDI.334': 'Driftstimer siden seneste slibning',
		'ISOBUS.DDI.335': 'Driftstimer kraftudtagsaksel foran',
		'ISOBUS.DDI.336': 'Driftstimer kraftudtagsaksel bagved',
		'ISOBUS.DDI.337': 'Driftstimer kraftudtagsaksel foran i alt',
		'ISOBUS.DDI.338': 'Driftstimer kraftudtagsaksel bagved i alt',
		'ISOBUS.DDI.339': 'Tid læsning',
		'ISOBUS.DDI.34': 'Minimal applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.340': 'Tid losning',
		'ISOBUS.DDI.341': 'Indstillingsværdi åbning Corn-Cracker',
		'ISOBUS.DDI.342': 'Faktisk værdi åbning Corn-Cracker',
		'ISOBUS.DDI.343': 'Minimal åbning Corn-Cracker',
		'ISOBUS.DDI.344': 'Maksimal åbning Corn-Cracker',
		'ISOBUS.DDI.345': 'Indstillingsværdi skårbredde',
		'ISOBUS.DDI.346': 'Faktisk værdi skårbredde',
		'ISOBUS.DDI.347': 'Minimal skårbredde',
		'ISOBUS.DDI.348': 'Maksimal skårbredde',
		'ISOBUS.DDI.349': 'Afdriftsklasse dyse',
		'ISOBUS.DDI.35': 'Maksimal applikationsmængde pr. udbringningsmængde',
		'ISOBUS.DDI.350': 'Funktion eller flytning',
		'ISOBUS.DDI.351': 'Udbringningsmængde i alt',
		'ISOBUS.DDI.352': 'Udbringningsmængde i alt',
		'ISOBUS.DDI.353': 'Udbringningsmængde kvælstof',
		'ISOBUS.DDI.354': 'Udbringningsmængde ammonium',
		'ISOBUS.DDI.355': 'Udbringningsmængde fosfor',
		'ISOBUS.DDI.356': 'Udbringningsmængde kalium',
		'ISOBUS.DDI.357': 'Udbringningsmængde tørstof',
		'ISOBUS.DDI.358': 'Høstmængde tørstof',
		'ISOBUS.DDI.359': 'Høstmængde tørstof',
		'ISOBUS.DDI.36': 'Indstillingsværdi udbringningsmængde',
		'ISOBUS.DDI.360': 'Størrelse seneste balle',
		'ISOBUS.DDI.361': 'Tæthed seneste balle',
		'ISOBUS.DDI.362': 'Ballelængde i alt',
		'ISOBUS.DDI.363': 'Tørstof seneste balle',
		'ISOBUS.DDI.364': 'Størrelse delballer',
		'ISOBUS.DDI.365': 'Indstillingsværdi skærtryk',
		'ISOBUS.DDI.366': 'Faktisk værdi skærtryk',
		'ISOBUS.DDI.367': 'Status overstyring arbejdsstilling enheder 1-16',
		'ISOBUS.DDI.368': 'Status overstyring arbejdsstilling enheder 17-32',
		'ISOBUS.DDI.369': 'Status overstyring arbejdsstilling enheder 33-48',
		'ISOBUS.DDI.37': 'Faktisk værdi udbringningsmængde',
		'ISOBUS.DDI.370': 'Status overstyring arbejdsstilling enheder 49-64',
		'ISOBUS.DDI.371': 'Status overstyring arbejdsstilling enheder 65-80',
		'ISOBUS.DDI.372': 'Status overstyring arbejdsstilling enheder 81-96',
		'ISOBUS.DDI.373': 'Status overstyring arbejdsstilling enheder 97-112',
		'ISOBUS.DDI.374': 'Status overstyring arbejdsstilling enheder 113-128',
		'ISOBUS.DDI.375': 'Status overstyring arbejdsstilling enheder 129-144',
		'ISOBUS.DDI.376': 'Status overstyring arbejdsstilling enheder 145-160',
		'ISOBUS.DDI.377': 'Status overstyring arbejdsstilling enheder 161-176',
		'ISOBUS.DDI.378': 'Status overstyring arbejdsstilling enheder 177-192',
		'ISOBUS.DDI.379': 'Status overstyring arbejdsstilling enheder 193-208',
		'ISOBUS.DDI.38': 'Forudindstillet udbringningsmængde',
		'ISOBUS.DDI.380': 'Status overstyring arbejdsstilling enheder 209-224',
		'ISOBUS.DDI.381': 'Status overstyring arbejdsstilling enheder 225-240',
		'ISOBUS.DDI.382': 'Status overstyring arbejdsstilling enheder 241-256',
		'ISOBUS.DDI.383': 'Tilsyneladende vindretning',
		'ISOBUS.DDI.384': 'Tilsyneladende vindhastighed',
		'ISOBUS.DDI.385': 'Lufttryk MSL',
		'ISOBUS.DDI.386': 'Faktisk værdi lufttryk',
		'ISOBUS.DDI.387': 'Omdrejninger i alt',
		'ISOBUS.DDI.388': 'Omdrejninger i alt',
		'ISOBUS.DDI.389': 'Indstillingsværdi omdrejningstal',
		'ISOBUS.DDI.39': 'Minimal udbringningsmængde',
		'ISOBUS.DDI.390': 'Faktisk værdi omdrejningstal',
		'ISOBUS.DDI.391': 'Forudindstillet omdrejningstal',
		'ISOBUS.DDI.392': 'Minimalt omdrejningstal',
		'ISOBUS.DDI.393': 'Maksimalt omdrejningstal',
		'ISOBUS.DDI.394': 'Fyldeniveau brændstoftank',
		'ISOBUS.DDI.395': 'Fyldeniveau Ad-Blue tank',
		'ISOBUS.DDI.396': 'Indstillingsværdi hastighed',
		'ISOBUS.DDI.397': 'Faktisk værdi hastighed',
		'ISOBUS.DDI.398': 'Minimal hastighed',
		'ISOBUS.DDI.399': 'Maksimal hastighed',
		'ISOBUS.DDI.4': 'Minimal udbringningsmængde',
		'ISOBUS.DDI.40': 'Maksimal udbringningsmængde',
		'ISOBUS.DDI.400': 'Type signal kørehastighed',
		'ISOBUS.DDI.401': 'Udbringningsmængde kvælstof',
		'ISOBUS.DDI.402': 'Udbringningsmængde ammonium',
		'ISOBUS.DDI.403': 'Udbringningsmængde fosfor',
		'ISOBUS.DDI.404': 'Udbringningsmængde kalium',
		'ISOBUS.DDI.405': 'Udbringningsmængde tørstof',
		'ISOBUS.DDI.406': 'Faktisk værdi proteinindhold',
		'ISOBUS.DDI.407': 'Gennemsnitligt proteinindhold',
		'ISOBUS.DDI.408': 'Gennemsnitlig forurening høstmateriale',
		'ISOBUS.DDI.409': 'Ad-Blue forbrug',
		'ISOBUS.DDI.41': 'Indstillingsværdi udbringningsmængde',
		'ISOBUS.DDI.410': 'Ad-Blue forbrug',
		'ISOBUS.DDI.411': 'Ad-Blue forbrug',
		'ISOBUS.DDI.412': 'Ad-Blue forbrug i alt',
		'ISOBUS.DDI.413': 'Ad-Blue forbrug i alt',
		'ISOBUS.DDI.414': 'Ad-Blue forbrug i alt',
		'ISOBUS.DDI.415': 'Faktisk værdi enkeltaflægning såsæd',
		'ISOBUS.DDI.416': 'Gennemsnitlig enkeltaflægning såsæd',
		'ISOBUS.DDI.417': 'Faktisk værdi manglende steder såsæd',
		'ISOBUS.DDI.418': 'Gennemsnitsværdi manglende steder såsæd',
		'ISOBUS.DDI.419': 'Faktisk værdi dobbeltsteder såsæd',
		'ISOBUS.DDI.42': 'Faktisk værdi udbringningsmængde',
		'ISOBUS.DDI.420': 'Gennemsnitsværdi dobbeltsteder såsæd',
		'ISOBUS.DDI.421': 'Standardafvigelse såsædsafstand fra indstillingsværdi',
		'ISOBUS.DDI.422': 'Gennemsnitlig standardafvigelse såsædsafstand fra indstillingsværdi',
		'ISOBUS.DDI.423': 'Aktuel variantionskoefficient såsædsafstand',
		'ISOBUS.DDI.424': 'Gennemsnitlig variantionskoefficient såsædsafstand',
		'ISOBUS.DDI.425': 'Indstillingsværdi maksimalt tilladt afvigelse såsædsafstand',
		'ISOBUS.DDI.426': 'Indstillingsværdi skærtryk',
		'ISOBUS.DDI.427': 'Indstillingsværdi skærtryk',
		'ISOBUS.DDI.428': 'Mængde læsning',
		'ISOBUS.DDI.429': 'Mængde losning',
		'ISOBUS.DDI.43': 'Forudindstillet udbringningsmængde',
		'ISOBUS.DDI.430': 'Mængde læsning i alt',
		'ISOBUS.DDI.431': 'Mængde losning i alt',
		'ISOBUS.DDI.432': 'Indstillingsværdi udbringningsmængde kvælstof',
		'ISOBUS.DDI.433': 'Faktisk værdi udbringningsmængde kvælstof',
		'ISOBUS.DDI.434': 'Minimal udbringningsmængde kvælstof',
		'ISOBUS.DDI.435': 'Maksimal udbringningsmængde kvælstof',
		'ISOBUS.DDI.436': 'Faktisk udbringningsmængde ammonium',
		'ISOBUS.DDI.437': 'Faktisk værdi udbringningsmængde ammonium',
		'ISOBUS.DDI.438': 'Minimal udbringningsmængde ammonium',
		'ISOBUS.DDI.439': 'Maksimal udbringningsmængde ammonium',
		'ISOBUS.DDI.44': 'Minimal udbringningsmængde',
		'ISOBUS.DDI.440': 'Indstillingsværdi udbringningsmængde fosfor',
		'ISOBUS.DDI.441': 'Faktisk værdi udbringningsmængde fosfor',
		'ISOBUS.DDI.442': 'Minimal udbringningsmængde fosfor',
		'ISOBUS.DDI.443': 'Maksimal udbringningsmængde fosfor',
		'ISOBUS.DDI.444': 'Faktisk værdi udbringningsmængde kalium',
		'ISOBUS.DDI.445': 'Faktisk værdi udbringningsmængde kalium',
		'ISOBUS.DDI.446': 'Minimal udbringningsmængde kalium',
		'ISOBUS.DDI.447': 'Maksimal udbringningsmængde kalium',
		'ISOBUS.DDI.448': 'Indstillingsværdi udbringningsmængde tørstof',
		'ISOBUS.DDI.449': 'Faktisk værdi udbringningsmængde tørstof',
		'ISOBUS.DDI.45': 'Maksimal udbringningsmængde',
		'ISOBUS.DDI.450': 'Minimal udbringningsmængde tørstof',
		'ISOBUS.DDI.451': 'Maksimal udbringningsmængde tørstof',
		'ISOBUS.DDI.452': 'Mængde læsning',
		'ISOBUS.DDI.453': 'Mængde losning',
		'ISOBUS.DDI.454': 'Mængde læsning i alt',
		'ISOBUS.DDI.455': 'Mængde losning i alt',
		'ISOBUS.DDI.456': 'Senest læsset mængde',
		'ISOBUS.DDI.457': 'Senest losset mængde',
		'ISOBUS.DDI.458': 'Mængde læsning',
		'ISOBUS.DDI.459': 'Mængde losning',
		'ISOBUS.DDI.46': 'Indstillingsværdi udbringningsmængde',
		'ISOBUS.DDI.460': 'Mængde læsning i alt',
		'ISOBUS.DDI.461': 'Mængde losning i alt',
		'ISOBUS.DDI.462': 'Senest læsset mængde',
		'ISOBUS.DDI.463': 'Senest losset mængde',
		'ISOBUS.DDI.464': 'Transport-tæller',
		'ISOBUS.DDI.465': 'Fyldecyklusser i alt',
		'ISOBUS.DDI.466': 'Vinkel påhæng',
		'ISOBUS.DDI.467': 'Fyldeniveau',
		'ISOBUS.DDI.468': 'Jordtilstand sne / frost',
		'ISOBUS.DDI.469': 'Evalueret bundvandsindhold',
		'ISOBUS.DDI.47': 'Faktisk værdi udbringningsmængde',
		'ISOBUS.DDI.470': 'Jordkomprimering',
		'ISOBUS.DDI.472': 'Indstillingsværdi skærelængde',
		'ISOBUS.DDI.473': 'Minimal skærelængde',
		'ISOBUS.DDI.474': 'Maksimal skærelængde',
		'ISOBUS.DDI.475': 'Indstillingsværdi pressetryk',
		'ISOBUS.DDI.476': 'Minimalt pressetryk',
		'ISOBUS.DDI.477': 'Maksimalt pressetryk',
		'ISOBUS.DDI.478': 'Indstillingsværdi størrelse delballer',
		'ISOBUS.DDI.479': 'Minimal størrelse delballer',
		'ISOBUS.DDI.48': 'Forudindstillet udbringningsmængde',
		'ISOBUS.DDI.480': 'Maksimal størrelse delballe',
		'ISOBUS.DDI.481': 'Indstillingsværdi antal delballer',
		'ISOBUS.DDI.482': 'Seneste balle antal delballer',
		'ISOBUS.DDI.483': 'Indstillingsværdi motoromdrejningstal',
		'ISOBUS.DDI.484': 'Faktisk værdi motoromdrejningstal',
		'ISOBUS.DDI.485': 'Minimalt motoromdrejningstal',
		'ISOBUS.DDI.486': 'Maksimalt motoromdrejningstal',
		'ISOBUS.DDI.488': 'Fyldeniveau Ad-Blue tank',
		'ISOBUS.DDI.489': 'Volumen Ad-Blue tank',
		'ISOBUS.DDI.49': 'Minimal udbringningsmængde',
		'ISOBUS.DDI.490': 'Volumen brændstoftank',
		'ISOBUS.DDI.491': 'Fyldeniveau brændstoftank',
		'ISOBUS.DDI.492': 'Driftstimer motor',
		'ISOBUS.DDI.493': 'Driftstimer motor i alt',
		'ISOBUS.DDI.494': 'Partner-ID for seneste hændelse (byte 1-4)',
		'ISOBUS.DDI.495': 'Partner-ID for seneste hændelse (byte 5-8)',
		'ISOBUS.DDI.496': 'Partner-ID for seneste hændelse (byte 9-12)',
		'ISOBUS.DDI.497': 'Partner-ID for seneste hændelse (byte 13-16)',
		'ISOBUS.DDI.498': 'Partner-ID for seneste hændelse type',
		'ISOBUS.DDI.499': 'Partner-ID for seneste hændelse producent ID',
		'ISOBUS.DDI.5': 'Maksimal udbringningsmængde',
		'ISOBUS.DDI.50': 'Maksimal udbringningsmængde',
		'ISOBUS.DDI.500': 'Partner-ID for seneste hændelse Device Class',
		'ISOBUS.DDI.501': 'Indstillingsværdi motordrejningsmoment',
		'ISOBUS.DDI.502': 'Faktisk moment motordrejningsmoment',
		'ISOBUS.DDI.503': 'Minimalt motordrejningsmoment',
		'ISOBUS.DDI.504': 'Maksimalt motordrejningsmoment',
		'ISOBUS.DDI.505': 'Funktion sporvejkobling',
		'ISOBUS.DDI.506': 'Indstillingsværdi sporvejkobling',
		'ISOBUS.DDI.507': 'Løbende nummer for sporvej',
		'ISOBUS.DDI.508': 'Entydige A-B linjer ID',
		'ISOBUS.DDI.509': 'Aktuelt spor',
		'ISOBUS.DDI.51': 'Indstillingsværdi jordbearbejdningsdybde',
		'ISOBUS.DDI.510': 'Nummer højre spor',
		'ISOBUS.DDI.511': 'Nummer venstre spor',
		'ISOBUS.DDI.512': 'Afstand sporlinjer',
		'ISOBUS.DDI.513': 'Afvigelse DRP til sporlinje',
		'ISOBUS.DDI.514': 'GNSS-kvalitet',
		'ISOBUS.DDI.515': 'Status plejesporkobling',
		'ISOBUS.DDI.516': 'Plejespor-overdosering',
		'ISOBUS.DDI.517': 'Indstillingsværdi arbejdsstilling plejespor 1-16',
		'ISOBUS.DDI.518': 'Faktisk værdi arbejdsstilling plejespor 1-16',
		'ISOBUS.DDI.519': 'Antal baller i alt',
		'ISOBUS.DDI.52': 'Faktisk værdi jordbearbejdningsdybde',
		'ISOBUS.DDI.520': 'Faktisk værdi højde afdækning',
		'ISOBUS.DDI.521': 'Type GNSS modtager',
		'ISOBUS.DDI.522': 'Antal bundne baller',
		'ISOBUS.DDI.523': 'Antal viklede baller',
		'ISOBUS.DDI.524': 'Antal bundne baller i alt',
		'ISOBUS.DDI.525': 'Antal viklede baller i alt',
		'ISOBUS.DDI.526': 'Faktisk værdi kølemiddeltemperatur',
		'ISOBUS.DDI.528': 'Ydelse sidste balle',
		'ISOBUS.DDI.529': 'Indstillingsværdi indstillingsvinkel skiver',
		'ISOBUS.DDI.53': 'Forudindstillet jordbearbejdningsdybde',
		'ISOBUS.DDI.530': 'Faktisk værdi indstillingsvinkel skiver',
		'ISOBUS.DDI.531': 'Faktisk værdi anvendt konserveringsmiddel',
		'ISOBUS.DDI.532': 'Indstillingsværdi anvendt konserveringsmiddel',
		'ISOBUS.DDI.533': 'Forhåndsindstilling anvendt konserveringsmiddel',
		'ISOBUS.DDI.534': 'Minimum anvendt konserveringsmiddel',
		'ISOBUS.DDI.535': 'Maksimalt anvendt konserveringsmiddel',
		'ISOBUS.DDI.536': 'Mængde konserveringsmiddel',
		'ISOBUS.DDI.537': 'Mængde konserveringsmiddel i alt',
		'ISOBUS.DDI.538': 'Gennemsnit anvendt konserveringsmiddel',
		'ISOBUS.DDI.539': 'Volumen tank konserveringsmiddel',
		'ISOBUS.DDI.54': 'Minimal jordbearbejdningsdybde',
		'ISOBUS.DDI.540': 'Påfyldningsniveau tank konserveringsmiddel',
		'ISOBUS.DDI.541': 'Faktisk værdi omdrejningstal kraftudtagsaksel',
		'ISOBUS.DDI.542': 'Indstillingsværdi omdrejningstal kraftudtagsaksel',
		'ISOBUS.DDI.543': 'Forhåndsindstilling omdrejningstal kraftudtagsaksel',
		'ISOBUS.DDI.544': 'Minimalt omdrejningstal kraftudtagsaksel',
		'ISOBUS.DDI.545': 'Maksimalt omdrejningstal kraftudtagsaksel',
		'ISOBUS.DDI.546': 'Tromletimer i alt',
		'ISOBUS.DDI.547': 'Indstillingsværdi pressekraft',
		'ISOBUS.DDI.548': 'Faktisk pressekraft',
		'ISOBUS.DDI.549': 'Gennemsnitligt pressekraft sidste balle',
		'ISOBUS.DDI.55': 'Maksimal jordbearbejdningsdybde',
		'ISOBUS.DDI.550': 'Jorddækning',
		'ISOBUS.DDI.551': 'Faktisk værdi drejemoment kraftudtagsaksel',
		'ISOBUS.DDI.552': 'Faktisk værdi drejemoment kraftudtagsaksel',
		'ISOBUS.DDI.553': 'Forhåndsindstilling drejemoment kraftudtagsaksel',
		'ISOBUS.DDI.554': 'Minimalt drejemoment kraftudtagsaksel',
		'ISOBUS.DDI.555': 'Maksimalt drejemoment kraftudtagsaksel',
		'ISOBUS.DDI.556': 'Aktuelle vejrbetingelser',
		'ISOBUS.DDI.557': 'Indstillingsværdi strøm',
		'ISOBUS.DDI.558': 'Faktisk værdi strøm',
		'ISOBUS.DDI.559': 'Minimal strøm',
		'ISOBUS.DDI.56': 'Indstillingsværdi udsåningsdybde',
		'ISOBUS.DDI.560': 'Maksimal strøm',
		'ISOBUS.DDI.561': 'Forhåndsindstilling strøm',
		'ISOBUS.DDI.562': 'Indstillingsværdi spænding',
		'ISOBUS.DDI.563': 'Forhåndsindstilling spænding',
		'ISOBUS.DDI.564': 'Faktisk spænding',
		'ISOBUS.DDI.565': 'Minimal spænding',
		'ISOBUS.DDI.566': 'Maksimal spænding',
		'ISOBUS.DDI.567': 'Faktisk værdi modstand',
		'ISOBUS.DDI.568': 'Indstillingsværid ydelse',
		'ISOBUS.DDI.569': 'Faktisk værdi ydelse',
		'ISOBUS.DDI.57': 'Faktisk værdi udsåningsdybde',
		'ISOBUS.DDI.570': 'Forhåndsindstilling ydelse',
		'ISOBUS.DDI.571': 'Maksimal ydelse',
		'ISOBUS.DDI.572': 'Minimal ydelse',
		'ISOBUS.DDI.573': 'Elektrisk energi i alt',
		'ISOBUS.DDI.574': 'Indstillingsværdi energimængde',
		'ISOBUS.DDI.575': 'Faktisk værdi energimængde',
		'ISOBUS.DDI.576': 'Minimal energimængde',
		'ISOBUS.DDI.577': 'Maksimal energimængde',
		'ISOBUS.DDI.578': 'Indstillingsværdi temperatur',
		'ISOBUS.DDI.579': 'Faktisk værdi temperatur',
		'ISOBUS.DDI.58': 'Forudindstillet udsåningsdybde',
		'ISOBUS.DDI.580': 'Minimal temperatur',
		'ISOBUS.DDI.581': 'Maksimal temperatur',
		'ISOBUS.DDI.582': 'Forhåndsindstilling temperatur',
		'ISOBUS.DDI.583': 'Indstillingsværdi frekvens',
		'ISOBUS.DDI.584': 'Faktisk værdi frekvens',
		'ISOBUS.DDI.585': 'Minimal frekvens',
		'ISOBUS.DDI.586': 'Maksimal frekvens',
		'ISOBUS.DDI.587': 'Forrige nedbør',
		'ISOBUS.DDI.588': 'Indstillingsværdi udbringningsmængde',
		'ISOBUS.DDI.589': 'Faktisk værdi udbringningsmængde',
		'ISOBUS.DDI.59': 'Minimal udsåningsdybde',
		'ISOBUS.DDI.590': 'Minimal udbringningsmængde',
		'ISOBUS.DDI.591': 'Maksimal udbringningsmængde',
		'ISOBUS.DDI.592': 'Forudindstilling udbringningsmængde',
		'ISOBUS.DDI.593': 'Type chassis',
		'ISOBUS.DDI.594': 'Type styring',
		'ISOBUS.DDI.595': 'Maskinstatus',
		'ISOBUS.DDI.596': 'Status lastrumstildækning',
		'ISOBUS.DDI.597': 'Strækning',
		'ISOBUS.DDI.598': 'Strækning i alt',
		'ISOBUS.DDI.599': 'Strækning mark',
		'ISOBUS.DDI.6': 'Indstillingsværdi udbringningsmængde',
		'ISOBUS.DDI.60': 'Maksimal udsåningsdybde',
		'ISOBUS.DDI.600': 'Strækning mark i alt',
		'ISOBUS.DDI.601': 'Strækning vej',
		'ISOBUS.DDI.602': 'Strækning vej i alt',
		'ISOBUS.DDI.603': 'Faktisk værdi status arbejdsstilling sporvej enheder 17-32',
		'ISOBUS.DDI.604': 'Faktisk værdi status arbejdsstilling sporvej enheder 33-48',
		'ISOBUS.DDI.605': 'Faktisk værdi status arbejdsstilling sporvej enheder 49-64',
		'ISOBUS.DDI.606': 'Faktisk værdi status arbejdsstilling sporvej enheder 65-80',
		'ISOBUS.DDI.607': 'Faktisk værdi status arbejdsstilling sporvej enheder 81-96',
		'ISOBUS.DDI.608': 'Faktisk værdi status arbejdsstilling sporvej enheder 97-112',
		'ISOBUS.DDI.609': 'Faktisk værdi status arbejdsstilling sporvej enheder 113-128',
		'ISOBUS.DDI.61': 'Indstillingsværdi arbejdshøjde',
		'ISOBUS.DDI.610': 'Faktisk værdi status arbejdsstilling sporvej enheder 129-144',
		'ISOBUS.DDI.611': 'Faktisk værdi status arbejdsstilling sporvej enheder 145-160',
		'ISOBUS.DDI.612': 'Faktisk værdi status arbejdsstilling sporvej enheder 161-176',
		'ISOBUS.DDI.613': 'Faktisk værdi status arbejdsstilling sporvej enheder 177-192',
		'ISOBUS.DDI.614': 'Faktisk værdi status arbejdsstilling sporvej enheder 193-208',
		'ISOBUS.DDI.615': 'Faktisk værdi status arbejdsstilling sporvej enheder 209-224',
		'ISOBUS.DDI.616': 'Faktisk værdi status arbejdsstilling sporvej enheder 225-240',
		'ISOBUS.DDI.617': 'Faktisk værdi status arbejdsstilling sporvej enheder 241-256',
		'ISOBUS.DDI.618': 'Faktisk værdi status arbejdsstilling sporvej enheder 17-32',
		'ISOBUS.DDI.619': 'Faktisk værdi status arbejdsstilling sporvej enheder 33-48',
		'ISOBUS.DDI.62': 'Faktisk værdi arbejdshøjde',
		'ISOBUS.DDI.620': 'Faktisk værdi status arbejdsstilling sporvej enheder 49-64',
		'ISOBUS.DDI.621': 'Faktisk værdi status arbejdsstilling sporvej enheder 65-80',
		'ISOBUS.DDI.622': 'Faktisk værdi status arbejdsstilling sporvej enheder 81-96',
		'ISOBUS.DDI.623': 'Faktisk værdi status arbejdsstilling sporvej enheder 97-112',
		'ISOBUS.DDI.624': 'Faktisk værdi status arbejdsstilling sporvej enheder 113-128',
		'ISOBUS.DDI.625': 'Faktisk værdi status arbejdsstilling sporvej enheder 129-144',
		'ISOBUS.DDI.626': 'Faktisk værdi status arbejdsstilling sporvej enheder 145-160',
		'ISOBUS.DDI.627': 'Faktisk værdi status arbejdsstilling sporvej enheder 161-176',
		'ISOBUS.DDI.628': 'Faktisk værdi status arbejdsstilling sporvej enheder 177-192',
		'ISOBUS.DDI.629': 'Faktisk værdi status arbejdsstilling sporvej enheder 193-208',
		'ISOBUS.DDI.63': 'Forudindstillet arbejdshøjde',
		'ISOBUS.DDI.630': 'Faktisk værdi status arbejdsstilling sporvej enheder 209-224',
		'ISOBUS.DDI.631': 'Faktisk værdi status arbejdsstilling sporvej enheder 225-240',
		'ISOBUS.DDI.632': 'Faktisk værdi status arbejdsstilling sporvej enheder 241-256',
		'ISOBUS.DDI.634': 'Faktisk volumen pr. distance Anvendelseshastighed',
		'ISOBUS.DDI.635': 'Standardmængde pr. distance Anvendelseshastighed',
		'ISOBUS.DDI.636': 'Minimumsvolumen pr. afstand Anvendelseshastighed',
		'ISOBUS.DDI.637': 'Maksimal mængde pr. afstand Anvendelseshastighed',
		'ISOBUS.DDI.638': 'Indstillingspunkt for dæktryk',
		'ISOBUS.DDI.639': 'Faktisk dæktryk',
		'ISOBUS.DDI.64': 'Minimal arbejdshøjde',
		'ISOBUS.DDI.640': 'Standard dæktryk',
		'ISOBUS.DDI.641': 'Minimum dæktryk',
		'ISOBUS.DDI.642': 'Maksimalt dæktryk',
		'ISOBUS.DDI.643': 'Faktisk dæktemperatur',
		'ISOBUS.DDI.65': 'Maksimal arbejdshøjde',
		'ISOBUS.DDI.66': 'Indstillingsværdi arbejdsbredde',
		'ISOBUS.DDI.67': 'Faktisk værdi arbejdsbredde',
		'ISOBUS.DDI.68': 'Forudindstillet arbejdsbredde',
		'ISOBUS.DDI.69': 'Minimal arbejdsbredde',
		'ISOBUS.DDI.7': 'Faktisk værdi udbringningsmængde',
		'ISOBUS.DDI.70': 'Maksimal arbejdsbredde',
		'ISOBUS.DDI.71': 'Indstillingsværdi fyldeniveau',
		'ISOBUS.DDI.72': 'Faktisk værdi fyldeniveau',
		'ISOBUS.DDI.73': 'Maksimalt fyldeniveau',
		'ISOBUS.DDI.74': 'Indstillingsværdi fyldeniveau',
		'ISOBUS.DDI.75': 'Faktisk værdi fyldeniveau',
		'ISOBUS.DDI.76': 'Maksimalt fyldeniveau',
		'ISOBUS.DDI.77': 'Indstillingsværdi fyldeniveau',
		'ISOBUS.DDI.78': 'Faktisk værdi fyldeniveau',
		'ISOBUS.DDI.79': 'Maksimalt fyldeniveau',
		'ISOBUS.DDI.8': 'Forudindstillet udbringningsmængde',
		'ISOBUS.DDI.80': 'Udbringningsmængde i alt',
		'ISOBUS.DDI.81': 'Udbringningsmængde i alt',
		'ISOBUS.DDI.82': 'Udbringningsmængde i alt',
		'ISOBUS.DDI.83': 'Høstmængde',
		'ISOBUS.DDI.84': 'Høstmængde',
		'ISOBUS.DDI.85': 'Høstmængde',
		'ISOBUS.DDI.86': 'Høstmængde',
		'ISOBUS.DDI.87': 'Høstmængde',
		'ISOBUS.DDI.88': 'Høstmængde',
		'ISOBUS.DDI.89': 'Høstmængde i alt',
		'ISOBUS.DDI.9': 'Minimal udbringningsmængde',
		'ISOBUS.DDI.90': 'Høstmængde i alt',
		'ISOBUS.DDI.91': 'Høstmængde i alt',
		'ISOBUS.DDI.92': 'Høsttab',
		'ISOBUS.DDI.93': 'Høsttab',
		'ISOBUS.DDI.94': 'Høsttab',
		'ISOBUS.DDI.95': 'Høsttab',
		'ISOBUS.DDI.96': 'Høsttab',
		'ISOBUS.DDI.97': 'Høsttab',
		'ISOBUS.DDI.98': 'Høsttab relativt',
		'ISOBUS.DDI.99': 'Fugtighed høstmateriale',
		'ISOBUS.DEVICE_CLASS.0': 'NonSpec',
		'ISOBUS.DEVICE_CLASS.1': 'Tractor',
		'ISOBUS.DEVICE_CLASS.10': 'Irrigation',
		'ISOBUS.DEVICE_CLASS.11': 'Transport/Trailer',
		'ISOBUS.DEVICE_CLASS.12': 'Farm Yard Operations',
		'ISOBUS.DEVICE_CLASS.13': 'Powered Auxiliary Devices',
		'ISOBUS.DEVICE_CLASS.14': 'Special Crops',
		'ISOBUS.DEVICE_CLASS.15': 'Earth Work',
		'ISOBUS.DEVICE_CLASS.16': 'Skidder',
		'ISOBUS.DEVICE_CLASS.17': 'Sensor Systems',
		'ISOBUS.DEVICE_CLASS.18': '-',
		'ISOBUS.DEVICE_CLASS.19': 'Timber Harvesters',
		'ISOBUS.DEVICE_CLASS.2': 'Tillage',
		'ISOBUS.DEVICE_CLASS.20': 'Forwarders',
		'ISOBUS.DEVICE_CLASS.21': 'Timber Loaders',
		'ISOBUS.DEVICE_CLASS.22': 'Timber Processing Machines',
		'ISOBUS.DEVICE_CLASS.23': 'Mulchers',
		'ISOBUS.DEVICE_CLASS.24': 'Utility Vehicles',
		'ISOBUS.DEVICE_CLASS.25': 'Slurry/Manure Applicators',
		'ISOBUS.DEVICE_CLASS.26': 'Feeders/Mixers',
		'ISOBUS.DEVICE_CLASS.27': 'Weeders',
		'ISOBUS.DEVICE_CLASS.3': 'Secondary Tillage',
		'ISOBUS.DEVICE_CLASS.4': 'Planters/Seeders',
		'ISOBUS.DEVICE_CLASS.5': 'Fertilizers',
		'ISOBUS.DEVICE_CLASS.6': 'Sprayers',
		'ISOBUS.DEVICE_CLASS.7': 'Harvesters',
		'ISOBUS.DEVICE_CLASS.8': 'Root Harvesters',
		'ISOBUS.DEVICE_CLASS.9': 'Forage',
		'JOB.ARCHIVE.QUESTION': 'Er du sikker på, at det valgte job skal arkiveres?',
		'JOB.ARCHIVE.SUCCESS': 'Kørslen arkiveres',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'Jobbet kan ikke vises fuldstændigt. Ovenstående oplysninger kan være forældede og vil blive genberegnet.',
		'JOB.CURRENT_STATUS': 'Nuværende status',
		'JOB.DELETE.QUESTION': 'Er du sikker på, at den valgte kørsel skal slettes?',
		'JOB.DELETE.SUCCESS': 'Kørslen er markeret til sletning',
		'JOB.DETAILS': 'Jobdetaljer',
		'JOB.DRIVER_IMPLEMENT': 'Slet eller ændr driver/implementering.',
		'JOB.EDIT': 'Rediger job',
		'JOB.REGENERATE': 'Generer kørsel på ny',
		'JOB.REGENERATE.DRIVER': 'Opdater chaufførdata',
		'JOB.REGENERATE.FIELDS': 'Opdatering af feltdata',
		'JOB.REGENERATE.IMPLEMENT': 'Opdater påhængsredskabsdata',
		'JOB.REGENERATE.INTRO': 'Hvis faktureringsdata for maskiner, redskaber eller chauffører er blevet ændret, kan de også opdateres.',
		'JOB.REGENERATE.LOCATIONS': 'Opdatering af lokaliseringsdata',
		'JOB.REGENERATE.MACHINE': 'Opdater maskindata',
		'JOB.REGENERATE.QUESTION': 'Hvilke data skal opdateres?',
		'JOB.REGENERATE.SUCCESS': 'Kørsel genereres nu på ny',
		'JOB.SPLIT': 'Skil kørsel',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Tilføj separationstidspunkt',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'For sekundnøjagtige indstillinger kan skydeafbrydere også betjenes med piletasterne.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Tilføj / slet tid(er) til separering af kørsel.',
		'JOB.SPLIT.NO_CHANGE': 'Kørsel blev ikke ændret',
		'JOB.SPLIT.NO_SPLITS': 'Ingen separationstidspunkter valgt',
		'JOB.UPDATE': 'Opdater job(s)',
		'JOB.WAITING_TIME_UNTIL_READY': 'Afhængigt af den aktuelle status kan det tage et par minutter, før jobbet kan blive vist fuldstændigt.',
		'JOBS': 'Alle kørsler i drift',
		'JOBS.ALL': 'Alle job',
		'JOBS.ARCHIVE.PARTIAL': 'Nogle job er arkiveret.',
		'JOBS.ARCHIVE.QUESTION': 'Ønsker du virkelig at arkivere de valgte job?',
		'JOBS.ARCHIVE.SUCCESS': 'Jobs vil blive arkiveret',
		'JOBS.CREATE_TASK': 'Opret ordre',
		'JOBS.DELETE.QUESTION': 'Vil du virkelig slette de valgte jobs? Alle data fra jobbene vil blive fjernet irreversibelt.',
		'JOBS.DELETE.SUCCESS': 'Job vil blive slettet',
		'JOBS.DELETED.FAILURE': 'Nogle af jobbene kunne ikke slettes.',
		'JOBS.EDIT': 'Rediger job',
		'JOBS.EDIT.SUCCESS': 'Job vil blive redigeret',
		'JOBS.IN_TASK': 'Job i opgaver',
		'JOBS.MERGE.SUCCESS': 'Kørsler sammenføjes nu',
		'JOBS.MERGING': 'Samling af kørsler',
		'JOBS.NO': 'Ingen job',
		'JOBS.NOT_SELECTED': 'Klik på kørsler for at tilføje dem til ordren.',
		'JOBS.REGENERATE': 'Fornyelse af arbejdspladser',
		'JOBS.REGENERATE.SUCCESS': 'Der vil blive skabt nye arbejdspladser',
		'JOBS.SELECTED': 'Udvalgte job',
		'JOBS.TASK_CREATED': 'Task succesfuldt oprettet!',
		'JOBS.UPDATE.SUCCESS': 'Jobs vil blive opdateret',
		'JOBS.WITHOUT_TASK': 'Job uden opgave',
		'JOBS.WITH_TASK': 'Job i opgave',
		'KILOMETERS': 'Kilometer',
		'LANGUAGE': 'Sprog',
		'LANGUAGE.ADD': 'Tilføj sprog',
		'LANGUAGE.CODE': 'Sprogkode',
		'LANGUAGE.DEFAULT': 'Standardsprog',
		'LASTNAME': 'Efternavn',
		'LAST_ONLINE': 'Senest online',
		'LAST_UPDATED': 'Senest redigeret',
		'LATITUDE': 'Breddegrad',
		'LOAD.MORE': 'Læs mere',
		'LOADS': 'Loads',
		'LOCATION': 'Sted',
		'LOCATION.ADD': 'Tilføj placering',
		'LOCATION.ADD.SUCCESS': 'Placering succesfuldt tilføjet',
		'LOCATION.DEACTIVATE.QUESTION': 'Ønsker du virkelig at deaktivere placeringen?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Lokation deaktiveret med succes',
		'LOCATION.DELETE.QUESTION': 'Vil du virkelig slette placeringen?',
		'LOCATION.DELETE.SUCCESS': 'Placering slettet med succes',
		'LOCATION.DETAILS': 'Location details',
		'LOCATION.DRAW.START': 'Marker stedet på kortet nu!',
		'LOCATION.EDIT.SUCCESS': 'Placering redigeret med succes',
		'LOCATIONS': 'Stedadministration',
		'LOCATIONS.ALL': 'Alle steder',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Nogle af stederne kunne ikke deaktiveres.',
		'LOCATIONS.DEACTIVATE.QUESTION': 'Ønsker du virkelig at deaktivere lokationerne?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Lokationer deaktiveret med succes',
		'LOCATIONS.DELETE.FAILURE': 'Nogle af stederne kunne ikke slettes.',
		'LOCATIONS.DELETE.QUESTION': 'Vil du virkelig slette de valgte steder?',
		'LOCATIONS.DELETE.SUCCESS': 'Sted fjernet.',
		'LOCATIONS.NO': 'Ingen steder',
		'LOCATIONS.NOT_SELECTED': 'Ingen steder valgt',
		'LOCATIONS.REACTIVATE.FAILURE': 'Nogle af stederne kunne ikke genaktiveres.',
		'LOCATIONS.REACTIVATE.QUESTION': 'Vil du virkelig genaktivere de valgte steder?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Lokationer genaktiveret med succes',
		'LOCATIONS.SELECTED': 'Udvalgte steder',
		'LOG': 'Meddelelseslog',
		'LOGIN': 'Login',
		'LOGIN.NOT_UNLOCKED_YET': 'Konto endu ikke aktiveret?',
		'LOGIN.NO_ACCOUNT_YET': 'Endnu ingen konto?',
		'LOGIN.PASSWORD_FORGOTTEN': 'Glemt adgangskode?',
		'LOGIN.REGISTER': 'Registrering',
		'LOGIN.REMEMBER_PASSWORD': 'Husk adgangskode',
		'LOGIN.UNLOCK': 'Aktiver konto',
		'LOG_OUT': 'Log ud',
		'LONGITUDE': 'Længdegrad',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'Skift adgangskode',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Indtast den aktiveringskode, som du har modtaget via e-mail.',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Indtast din e-mail-adresse.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Indast en gyldig e-mail-adresse.',
		'MAC': 'MAC',
		'MACHINE': 'Køretøj',
		'MACHINE.ADD': 'Tilføj køretøj',
		'MACHINE.ADD.SUCCESS': 'Køretøj succesfuldt tilføjet',
		'MACHINE.DELETE.QUESTION': 'Er du sikker på, at køretøjet skal fjernes?',
		'MACHINE.DELETE.SUCCESS': 'Køretøj succesfuldt fjernet',
		'MACHINE.DETAILS': 'Køretøjsdetaljer',
		'MACHINE.EDIT': 'Rediger køretøj',
		'MACHINE.EDIT.SUCCESS': 'Køretøj succesfuldt redigeret',
		'MACHINE.INTERVAL.ADD': 'Tilføj maskininterval',
		'MACHINE.LIVE_STATUS': 'Status for maskine i live',
		'MACHINE.NO': 'Ingen maskine',
		'MACHINE.RELOAD_POSITIONS': 'Genindlæsning af maskinens positioner',
		'MACHINE.STATUS': 'Køretøjsstatus',
		'MACHINES': 'Køretøjer',
		'MACHINES.ALL': 'Alle maskiner',
		'MACHINES.DEACTIVATE.FAILURE': 'Nogle af maskinerne kunne ikke deaktiveres.',
		'MACHINES.DEACTIVATE.QUESTION': 'Vil du virkelig deaktivere de valgte maskiner?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Maskiner deaktiveret med succes',
		'MACHINES.DELETE.FAILURE': 'Nogle af maskinerne kunne ikke slettes.',
		'MACHINES.DELETE.QUESTION': 'Ønsker du virkelig at slette de valgte maskiner?',
		'MACHINES.DELETE.SUCCESS': 'Maskiner slettet med succes',
		'MACHINES.MANAGEMENT': 'Køretøjsadministration',
		'MACHINES.NO': 'Ingen maskiner',
		'MACHINES.NOT_SELECTED': 'Ingen maskiner valgt',
		'MACHINES.NO_LICENSE.WARNING': 'Maskinen har ingen tilknyttet licens. Uden en licens registreres der ingen data.',
		'MACHINES.REACTIVATE.FAILURE': 'Nogle af maskinerne kunne ikke genaktiveres.',
		'MACHINES.REACTIVATE.QUESTION': 'Vil du virkelig genaktivere de valgte maskiner?',
		'MACHINES.REACTIVATE.SUCCESS': 'Maskiner genaktiveret med succes',
		'MACHINES.SELECTED': 'Udvalgte maskiner',
		'MACHINE_COMBINATION': 'Machine combination',
		'MACHINE_IMPLEMENT': 'Maskine/implementering',
		'MAC_DEVICES': 'Adaptere forbundet med køretøjer',
		'MAINTENANCE': 'Vedligeholdelse',
		'MAINTENANCE.AMOUNT': 'Forfalden i/den',
		'MAINTENANCE.PERIOD': 'Vedligeholdelsesinterval',
		'MAKE': 'Mærke',
		'MANURE': 'Gødning',
		'MANURE.TYPE': 'Gødningstype',
		'MAP': 'Kort',
		'MAP.SECTION': 'Kortudsnit',
		'MAP.SECTION.CHANGE': 'Skift kortudsnit',
		'MARKER.ADD': 'Tilføj markering',
		'MARKER.EDIT.BORDERS': 'Rediger grænser',
		'MARKER.ENTRANCE': 'Tilkørsel',
		'MARKER.EXIT': 'Udkørsel',
		'MARKER.INFO': 'Info',
		'MARKER.WARN': 'Advarsel',
		'MAX': 'Max',
		'MAX_VALUE': 'Maksimal værdi',
		'MERGE': 'Sammenføj kørsler',
		'MESSAGES.NO': 'Der findes ingen meddelelser',
		'MILEAGE': 'Kilometerstand',
		'MILEAGE.INVALID': 'Kilometerstand ugyldig',
		'MIN': 'Min',
		'MIN_VALUE': 'Minimumsværdi',
		'MOBILE': 'Mobil',
		'MODE.SWITCH': 'Skift tilstanden',
		'MODEL': 'Model',
		'MYPROFILE': 'Min profil',
		'MYPROFILE.BASIC_DATA': 'Basisdata',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'Dine basisdata er succesfuldt blevet ændret',
		'NAME': 'Fornavn',
		'NAV.ACTIVITIES': 'Aktiviteter',
		'NAV.ADMIN': 'Administration',
		'NAV.ADMIN.DASHBOARD': 'Dashboard',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job import',
		'NAV.ADMIN.JOB_VIEW': 'Jobvisning',
		'NAV.ADMIN.USERS': 'Brugeradministration',
		'NAV.CUSTOMERS': 'Kunder',
		'NAV.DASHBOARD': 'Oversigt',
		'NAV.DATA_PREPARATION': 'Databehandling',
		'NAV.EMPLOYEES': 'Medarbejdere',
		'NAV.ENTERPRISE': 'Bedrift',
		'NAV.FIELDS': 'Marker',
		'NAV.FILE_TRANSFER': 'ISO data',
		'NAV.HARDWARE': 'Hardware',
		'NAV.HARDWARE_SETUP': 'Opsætning af hardware',
		'NAV.IMPLEMENTS': 'Påhængsredskaber/anhængere',
		'NAV.LOCATIONS': 'Steder',
		'NAV.MACHINES': 'Køretøjer',
		'NAV.MY_SECTION': 'Mit område',
		'NAV.PATH_PLANNINGS': 'Path planning',
		'NAV.RETAILER': 'Retailer',
		'NAV.SETTINGS': 'Indstillinger',
		'NAV.SETTINGS.ADAPTER': 'Adapter',
		'NAV.SETTINGS.GENERAL': 'Bedrift',
		'NAV.SETTINGS.PARTNER': 'Partner',
		'NAV.STATISTIC': 'Statistik',
		'NAV.TECH': 'TECH',
		'NAV.TRANSLATION.EDIT': 'Oversættelse redigere',
		'NAV.TRANSLATION_MANAGEMENT': 'Forvaltning af oversættelser',
		'NETWORK.ACCESS_TECHNOLOGY': 'Adgang til teknologi',
		'NETWORK.OPERATOR': 'Operatør',
		'NEXT': 'Næste',
		'NO': 'Nej',
		'NONE': 'Ingen',
		'NOTICE': 'Bemærk',
		'NON_PRODUCTIVE_TIME': 'Ikke-produktiv tid',
		'NON_PRODUCTIVE_TIMES': 'Ikke-produktive tider',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Separator for non productive time computation',
		'NOT_READ': 'kunne ikke læses.',
		'NO_DATA': 'Ingen data',
		'ONLY_ON': 'Kun på',
		'OPACITY': 'Dækkraft',
		'OPERATING_HOURS': 'Driftstid',
		'OPERATING_HOURS.INVALID': 'Driftstimer ugyldige',
		'OPERATION': 'Operation',
		'OPERATION.NOT_SELECTED': 'Vælg først en foranstaltning fra tabellen!',
		'OPERATION.SELECT': 'Vælg operation',
		'OPERATIONS': 'Operationer',
		'OPERATIONS.ARRIVAL': 'Ankomst',
		'OPERATIONS.CUSTOMER': 'Operationer for kunden',
		'OPERATIONS.FIELD': 'Operationer på stedet',
		'OPERATIONS.FIELDS': 'Operationer på felter',
		'OPERATIONS.FIELD_TIME': 'Tid i marken',
		'OPERATIONS.GEOMETRY': 'Geometri',
		'OPERATIONS.LOCATION': 'Operationer på stedet',
		'OPERATIONS.LOCATIONS': 'Operationer på steder',
		'OPERATIONS.NO': 'Ingen foranstaltninger fundet.',
		'OPERATIONS.PREPARATION': 'Forberedelse',
		'OVERRIDE.NO': 'Ingen tilsidesættelse',
		'PAGE': 'Page',
		'PAGE.OF': 'of',
		'PAGINATION.PER_PAGE': 'pr. side',
		'PAGINATION.TOTAL': 'i alt',
		'PAGINATOR.FIRST_PAGE': 'Første side',
		'PAGINATOR.ITEMS_PER_PAGE': 'Elementer pr. side',
		'PAGINATOR.LAST_PAGE': 'Sidste side',
		'PAGINATOR.NEXT_PAGE': 'Næste side',
		'PAGINATOR.OF': 'på',
		'PAGINATOR.PREVIOUS_PAGE': 'Forrige side',
		'PARTNER_CONNECTION': 'Fletning',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'Udløber ikke',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Udløber den',
		'PASSWORD': 'Adgangskode',
		'PASSWORD.CHANGE': 'Skift adgangskode',
		'PASSWORD.CHANGE.ACTIVATE': 'Nuværende adgangskode',
		'PASSWORD.CHANGE.SUCCESS': 'Dit adgangskode er succesfuldt blevet ændret',
		'PASSWORD.CONFIRM': 'Bekræft nyt adgangskode',
		'PASSWORD.LENGTH.REQUIRED': 'Adgangskoden skal være mindst 6 tegn lang',
		'PASSWORD.NEW_PASSWORD': 'Ny adgangskode',
		'PASSWORD.NO_MATCH': 'Manglende overensstemmelse mellem adgangskode og bekræftelse!',
		'PATH_PLANNING.ADD': 'Plan path',
		'PATH_PLANNING.ADD.SUCCESS': 'Planned path successfully added',
		'PATH_PLANNING.ANGLE': 'Angle',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Longest side',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Working angle',
		'PATH_PLANNING.AREA.COVERED': 'Covered area',
		'PATH_PLANNING.AREA.OVERLAP': 'Overlapped area',
		'PATH_PLANNING.AREA.UNCOVERED': 'Uncovered area',
		'PATH_PLANNING.DETAILS': 'Planned path',
		'PATH_PLANNING.GENERATE_PATH': 'Generate path',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'The field boundary has been changed. Do you want to store the boundary as the current boundary of the field?',
		'PATH_PLANNING.NAME': 'Path planning name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Give the path planning a name',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Currently there is not enough data to compute the expected fuel consumption, CO2 consumption and cost',
		'PATH_PLANNING.SELECT.FIELD': 'Select the field you want the path to be planned for',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Send to machine',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'The settings have been changed after generating the currently shown planned path and will not be reflected when saved. Do you want to continue?',
		'PATH_PLANNING.SUBDIVIDE': 'Subdivide field',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Some of the planned paths could not be deactivated',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the planned path?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Planned paths have been deactivated',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Some of the planned paths could not be deleted',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Do you really want to delete the planned path?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Planned paths deleted successfully',
		'PATH_PLANNINGS.MANAGEMENT': 'Planned paths management',
		'PATH_PLANNINGS.NOT_SELECTED': 'No planned path selected',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Some of the planned paths could not be reactivated',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected planned paths?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Planned paths reactivated successfully',
		'PATTERN': 'Pattern',
		'PATTERN.END_AT_ENTRANCE': 'End at entrance',
		'PATTERN.START': 'Pattern start/end',
		'PATTERN.START_AT_ENTRANCE': 'Start at entrance',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Gennemsnitlig præstation',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'Denne værdi tager også højde for alle arbejdstilstande, herunder forberedelses- og vejtider',
		'PERFORMANCE.AVERAGE.FIELD': 'Gennemsnitlig præstation (felt)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'Denne værdi tager kun højde for at arbejde på en mark, vente på en mark og tænde for en mark.',
		'PERFORMANCE.TOTAL': 'Samlet præstation',
		'PHONE': 'Kontakttelefon',
		'PHONE.INVALID': 'Telefonnummer ugyldigt',
		'PHONE_MOBILE': 'Telefon (mobil)',
		'PH_VALUE': 'PH-værdi',
		'PLAY': 'Play',
		"POI": "Point of interest",
		"POI.ADD": "Add point of interest",
		'POSTCODE': 'Postnummer',
		'PREVIOUS': 'Forrige',
		'PROCESS': 'Proces',
		'PROCESSED': 'Behandlet',
		'PROCESSED.FAILURE': 'Fejl under behandling',
		'PROCESSED.SUCCESSFULL': 'Behandlet med succes',
		'PRODUCT': 'Produkt',
		'PROGRESS': 'Fremskridt',
		'PROJECTION': 'Projektion',
		'RAW_DATA': 'Rå data',
		'RECEIVED.AT': 'Modtaget på',
		'REGENERATE': 'Regenerér',
		'REGENERATE.SELECTED': 'Regenerere valgt',
		'REGISTER': 'Registrering',
		'REGISTER.ALREADY_REGISTERED?': 'Er du allerede registreret?',
		'REGISTER.I_ACCEPT_THE': 'Jeg accepterer',
		'RELOAD': 'Genindlæs',
		'REMOVE': 'Fjern',
		'RENEW': 'Forny',
		'REOCURRING': 'Tilbagevendende',
		'REPORT': 'Rapport',
		'RESET': 'Nulstil',
		'RESOLUTION': 'Opløsning',
		'RESTORE.DRIVER': 'Gendan driver',
		'RESTORE.IMPLEMENT': 'Gendan implementeringen',
		'ROAD': 'Vej',
		'ROLE': 'Rolle',
		'RUNTIME_H': 'Løbetid i h',
		'SAFETY_CHECK': 'Sikkerhedstjek',
		'SATELITE': 'Satellit',
		'SAVE': 'Gem',
		'SCALE.TYPE': 'Skala type',
		'SEARCH': 'Søgning efter køretøjer',
		'SEASON_YEAR': 'Høstår',
		'SEASON_YEAR.START': 'Sæsonstart',
		'SELECT.ALL': 'Vælg alle',
		'SELECT.CLEAR': 'Fjern valg',
		'SELECT.FIELD': 'Select field',
		'SENSORDATA': 'Sensordata',
		'SENSORDATA.DESCRIPTION': 'Visning af sensordata som grafik',
		'SENSORDATA.SELECT_SENSOR': 'Vælg sensor',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Vis farver på arbejdstilstand',
		'SENSOR_PARAMETER': 'Sensorparameter',
		'SENSOR_PARAMETER.ADD': 'Tilføj sensorparameter',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Definer individuelle sensorparemeter for det valgte redskab.',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Definer din individuelle sensorparameter.',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Individuel sensorparameter',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'Sensorparameter anvendes i en anden parameterkonfiguration',
		'SENSOR_PARAMETERS': 'Sensorparametre',
		'SENSOR_PARAMETERS.NO': 'Ingen sensorparametre',
		'SERIAL': 'Serienummer',
		'SETTINGS': 'Settings',
		'SETTINGS.ADDITIONAL': 'Additional settings',
		'SETTINGS.ADVANCED': 'Advanced settings',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'Din Agrirouter konto kan forbindes med exatrek for at dele data.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'Agrirouter er forbundet og parat. Forbindelsen er gyldig indtil',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Forbindelse til exatrek-partnere',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Synkroniser marker fra 365farmnet til exatrek',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Synkroniser marker fra exatrek til 365farmnet',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Synkroniser marker fra exatrek til 365farmnet',
		'SETTINGS.GO_TO_FARMNET': 'GÅ TIL 365 FARMNET',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'Synkronisationsfunktionerne til og fra 365farmnet kan kun bruges direkte fra 365farmnet webapp’en.',
		'SHOW': 'Vis',
		'SHOW_DIRECTION': 'Vis retning',
		'SHOW_EVENTS': 'Vis hændelser',
		'SHOW_FIELDS': 'Vis felt',
		'SHOW_LOCATIONS': 'Vis steder',
		'SHOW_OFFLINE_MACHINES': 'Inaktive køretøjer',
		'SHOW_TRACKS': 'Kørespor',
		'SHOW_TRACKS_': 'Kørespor',
		'SNACKBAR.DAYS': 'dage',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'Din licens udløber i',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'Mindst én maskine har ikke været online i et stykke tid!',
		'SORT_BY': 'Opdeling efter',
		'SPEED': 'Hastighed',
		'SPEED.AVERAGE': 'Gennemsnitshastighed',
		'SPEED.FASTER': 'Faster',
		'SPEED.RESET': 'Reset speed',
		'SPEED.SIGNAL.OVERRIDE': 'Override af hastighedssignal',
		'SPEED.SLOWER': 'Slower',
		'SPEED.WORKING': 'Working speed',
		'SPLIT': 'Split',
		'START': 'Start',
		'STATISTICS': 'Statistics',
		'STATUS': 'Status',
		'STOP': 'Stop',
		'STORAGE': 'Opbevaring',
		'STORAGE.USB': 'USB-lagring',
		'STORAGE.USB.USED': 'USB storage used',
		'STORAGE.USED': 'Opbevaring brugt',
		'SYMBOLIZATION': 'Symbolforklaring',
		'TASK': 'Ordre',
		'TASK.ADDABLE_JOBS': 'Kørsler, som kan tilføjes',
		'TASK.ADD_JOBS': 'Tilføj kørsler',
		'TASK.ARCHIVED_JOB_WARNING': 'Denne ordre indeholder arkiverede kørsler og vises ikke fuldstændigt!',
		'TASK.DELETE.JOB.FAILURE': 'En opgave skal indeholde mindst ét job!',
		'TASK.DELETE.JOB.QUESTION': 'Ønsker du virkelig at slette jobbet fra opgaven?',
		'TASK.DELETE.JOB.SUCCESS': 'Job slettet fra opgave med succes',
		'TASK.DELETE.QUESTION': 'Ønsker du virkelig at slette opgaven?',
		'TASK.DELETE.SUCCESS': 'Opgave slettet med succes',
		'TASK.EDIT': 'Rediger ordre',
		'TASK.EDIT.SUCCESS': 'Opgave redigeret med succes',
		'TASK.EXPORT_DETAILS': 'Eksporter den valgte opgave',
		'TASK.JOBS_TO_ADD': 'Tilføjede kørsler',
		'TASK.NEW': 'Ny ordre',
		'TASKS': 'Ordrer',
		'TASKS.NO': 'Ingen opgaver',
		'TASK_CONTROLLER.ACTIVE': 'TaskController (DataLog) aktiv',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'Kompatibilitetstilstand for TaskController',
		'TAX_ID': 'CVR-NR.',
		'TC': 'Opgavecontroller',
		'TC.ACTIVE': 'TC aktiv',
		'TC.TC_COMP': 'TC comp.',
		'TERMINAL.NO': 'Ingen terminal',
		'TERMINAL.TYPE': 'Terminal type',
		'TEST.SUCCESS': 'Forespørgslen efter en test-konto er vellykket - du vil modtage en e-mail om kort tid',
		'TIME': 'Tid',
		'TIME.REMAINING': 'Resterende tid',
		'TIMEZONE': 'Tidszone',
		'TITLE': 'Forespørg om test-konto',
		'TOKEN': 'Access token',
		'TOTAL': 'Total',
		'TRACKS.LOADING': 'Indlæser kørespor...',
		'TRACK.WIDTH': 'Sporvidde',
		'TRACK.WIDTH.NARROW': 'Smal',
		'TRACK.WIDTH.NORMAL': 'Normal',
		'TRACK.WIDTH.WIDE': 'Bredt',
		'TRACK_LENGTH': 'Køresporlængde',
		'TRACK_REPLAY': 'Track replay',
		'TRANSLATABLE': 'Kan oversættes',
		'TRANSLATABLE.ADD': 'Tilføj oversættelig',
		'TRANSLATION': 'Oversættelse',
		'TRANSPORT': 'Transport',
		'TRANSPORT/AXLES': 'Transport/aksler',
		'TRANSPORTAMOUNT_AXLES': 'Transportmængde/aksler',
		'TURNINGS': 'Turnings',
		'TURNING_OFFSET': 'Turning offset',
		'TURNING_RADIUS': 'Turning radius',
		'TYPE': 'Type',
		'UNDO': 'Fortryd',
		'UNIT': 'Enhed',
		'UNKNOWN': 'Ukendt',
		'UNTIL': 'indtil',
		'UPLOAD': 'Upload',
		'UPLOAD.FINISHED': 'Upload færdig',
		'UPLOADING': 'Overførsel af',
		'USER.EDIT.SUCCESS': 'Bruger succesfuldt behandlet.',
		'USERNAME': 'Brugernavn',
		'USERNAME.LENGTH.REQUIRED': 'Brugernavnet skal indeholde mindst 6 tegn.',
		'USERNAME.TAKEN': 'Dette navn er allerede tildelt.',
		'USERNAME.VALID.CHARS': 'Brugernavnet må kun indeholde bogstaver, tal, \"-\" og \"_\"',
		'USERROLE': 'Brugerrolle',
		'USERSTATUS': 'Brugerstatus',
		'USER_CREATED': 'Bruger oprettet.',
		'WAITING': 'Venter',
		'WARNING': 'Advarsel',
		'WEEK.CURRENT': 'Skift til aktuel uge',
		'WEEK.NEXT': 'Næste uge',
		'WEEK.PREVIOUS': 'Forrige uge',
		'WEEK.SELECTED': 'Valgt uge',
		'WEIGHING': 'Vejning',
		'WIDTH.INVALID': 'Bredde ugyldig.',
		'WORKING_HOURS': 'Arbejdstid',
		'WORKING_TIME': 'Arbejdstid',
		'WORKING_WIDTH': 'Arbejdsbredde',
		'WORKSTATE': 'Arbejdstilstand',
		'WORKSTATES': 'Arbejdstilstande',
		'YES': 'Ja',
    'NO_POSITION_MACHINE_FOUND': 'Ingen positioner fundet',
	}
};
